import { CdkDrag, CdkDragDrop, CdkDropList, CdkDropListGroup } from '@angular/cdk/drag-drop';
import { CommonModule, DatePipe } from '@angular/common';
import { AfterViewChecked, Component, effect, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';
import { dispatchStorageKey } from './utils/dispatch.storage';
import { createSelector, Store } from '@ngrx/store';


import { QuillEditorComponent, QuillModules } from 'ngx-quill';
import { MenuItem, MessageService, PrimeIcons } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ButtonGroupModule } from 'primeng/buttongroup';
import { ContextMenu, ContextMenuModule } from 'primeng/contextmenu';
import { DividerModule } from 'primeng/divider';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ProgressBarModule } from 'primeng/progressbar';

import { Delta } from 'quill/core';






import type Quill from 'quill/core';
import { catchError, debounceTime, filter, firstValueFrom, interval, map, Observable, of, retry, shareReplay, skip, startWith, Subject, switchMap, take, timer , combineLatest } from 'rxjs';
import { SubSink } from 'subsink';
import { ScheduleControlsAction, ScheduleControlsConfig, ScheduleControlsService } from '../schedule-controls/schedule-controls.service';
import { v4 as uuid } from 'uuid';

import { environment } from '../../../environments/environment';
import { CalculateDistanceGQL, CalculateDistanceOutput, JobsV3PageGQL, JobDetailsV2Fragment, UpdateJobGQL, ViewDatesGQL } from '../../../generated/graphql.generated';
import { GraphQLModule } from '../../core/auth/graphql.module';
import { dayjs } from '../../core/dayjs/dayjs';
import { ArtifactService } from '../../core/public-api';
import { FreyaCommonModule } from '../../freya-common/freya-common.module';
import { CAPABILITIES_BACKEND_MAP, EventAttendeeRoles, jurisdictions } from '../../global.constants';
import { NavigatorStatusComponent } from '../../job/job-workorders/navigator-status/navigator-status.component';
import { BrandingService } from '../../services/branding.service';
import { DetailsHelperService } from '../../services/details-helper.service';
import { FreyaMutateService } from '../../services/freya-mutate.service';
import { PermissionService } from '../../services/permission.service';
import { TimezoneHelperService } from '../../services/timezone-helper.service';
import { PrintBolService } from '../../shared/bill-of-lading/print-bol.service';
import { SharedModule } from '../../shared/shared.module';
import { selectSystemDetails } from '../../state/branding.store';
import { selectFeature } from '../../state/featureFlags.store';
import { ExportableEvent, generateScheduleHtml } from '../schedule-export.util';

import { CustomBlockDialogComponent } from './components/custom-block-dialog/custom-block-dialog.component';

import { DispatchCalendarRemarksDialogActions } from './components/dispatch-calendar-remarks-dialog/dispatch-calendar-remarks-dialog.actions';
import { DispatchCalendarRemarksDialogComponent } from './components/dispatch-calendar-remarks-dialog/dispatch-calendar-remarks-dialog.component';
import { dispatchCalendarRemarksDialogFeature } from './components/dispatch-calendar-remarks-dialog/dispatch-calendar-remarks-dialog.feature';
import { AssetDragData, AttendeeDragData, DispatchCardComponent } from './components/dispatch-card/dispatch-card.component';
import { DispatchChipComponent } from './components/dispatch-chip/dispatch-chip.component';
import { DispatchCrewComponent } from "./components/dispatch-crew/dispatch-crew.component";
import { DispatchCrewSettingsComponent } from './components/dispatch-crew-settings/dispatch-crew-settings.component';
import { DispatchEditEventComponent } from './components/dispatch-edit-event/dispatch-edit-event.component';
import { DispatchOperationsReportComponent } from './components/dispatch-operations-report/dispatch-operations-report.component';
import { DispatchSendScheduleComponent } from './components/dispatch-send-schedule/dispatch-send-schedule.component';
import { DispatchSendScheduleDialogComponent } from './components/dispatch-send-schedule-dialog/dispatch-send-schedule-dialog.component';
import { OpsTaskDialogComponent } from './components/ops-task-dialog/ops-task-dialog.component';
import { PrintDispatchBolsDialogComponent } from './components/print-dispatch-bols-dialog/print-dispatch-bols-dialog.component';
import { DayEventsUpdatedGQL, DayEventsMutated } from './store/dispatch-live.store';
import { DispatchActions } from './store/dispatch.actions';
import {
  AdditionalEventStatuses,
  DispatchAllowedToDisplayStatuses,
  DispatchEvent,
  DispatchEventStatusOptions,
  DispatchFilterOption,
  DispatchGroupOptions,
  EVENT_STATUS_ICONS,
  opsTaskNotesPlainText,
  PotentialCrewMember,
} from './store/dispatch.reducer';
import {
  selectAreEventRequirementsSatisfied,
  selectAssignCrewInfeasibilityReasons,
  selectAssignCrewWithAILoading,
  selectIsAssignCrewDialogOpen,
  selectConflictingEvents,
  selectEventsLoaded,
  selectIsEditRateDialogOpen,
  selectIsSendScheduleDialogOpen,
  selectOpsManagerEvents,
  selectHasPendingChanges,
  selectAutosaveEnabled,
  selectIsSavingChanges,
  selectSaveError,
  selectPendingChangeCount,
  selectPotentialCrew,
  selectRouteGroupsWithMetrics,
  RouteGroupWithMetrics,
  selectSelectedOpsManagerIds,
  selectSelectedUserForRateEdit,
  selectLastEventsLoadedAt,
  selectLastPendingChangeAt,
  selectPendingChanges,
  selectSendScheduleCrewNotes,
  selectDispatchDate
} from './store/dispatch.selectors';

const selectFilteredCrewCount = createSelector(selectPotentialCrew, (crew) => crew.length);
import {
  formatArrivalWindow,
  formatDistance,
  formatDuration,
  formatInventoryVolume,
  formatInventoryWeight,
  formatTravelTime,
  getLocationLabel,
  getOrderedLocationsForDisplay,
  getOrderedLocationIdsForCalculation,
  parseCrewSummary,
  parseInventory
} from './utils/dispatch-report.utils';
import { CrewPersonalNote, getCrewPersonalNote } from './crew-personal-notes';

/**
 * One file attached through the Event Notes 📎 (Ray: "Add Attachment" inside
 * the Event Notes formatting tools — must be event-scoped, #6983). The
 * artifact holds the bytes; this rides on event metadata.eventAttachments so
 * it can only ever surface on the event it was attached to.
 */
interface EventNotesAttachment {
  /** Artifact the file lives in (download via url). */
  artifactId: string;
  name: string;
  contentType?: string;
  fileSize?: number;
  /** Public artifact URL — the click-through. */
  url?: string;
}

const GROUP_BY_OPTIONS: DispatchFilterOption<DispatchGroupOptions>[] = [
  {
    label: DispatchGroupOptions.Route,
    icon: PrimeIcons.TRUCK
  },
  {
    label: DispatchGroupOptions.StartTime,
    icon: PrimeIcons.CLOCK
  },
  {
    label: DispatchGroupOptions.EventType,
    icon: PrimeIcons.TAG
  },
  {
    label: DispatchGroupOptions.Status,
    icon: PrimeIcons.CHECK_CIRCLE
  },
  {
    label: DispatchGroupOptions.RequiresAttention,
    icon: PrimeIcons.EXCLAMATION_TRIANGLE
  },
  {
    label: DispatchGroupOptions.PaidStatus,
    icon: PrimeIcons.DOLLAR
  },
  // {
  //   label: DispatchGroupOptions.None,
  //   icon: PrimeIcons.BAN
  // },
] as const;

interface RouteCrewMember {
  name: string;
  isCrewLead?: boolean;
  isDriver?: boolean;
  userId: string;
}

const EVENT_STATUS_OPTIONS: DispatchFilterOption<DispatchEventStatusOptions>[] =
Object.entries(EVENT_STATUS_ICONS)
  .filter(([key]) =>
    Object.values(DispatchAllowedToDisplayStatuses).includes(key as DispatchAllowedToDisplayStatuses) ||
    Object.values(AdditionalEventStatuses).includes(key as AdditionalEventStatuses)
  )
  .map(
    ([label, icon]) => ({
      label: label as DispatchEventStatusOptions,
      icon: icon as PrimeIcons
    })
  );

@Component({
  standalone: true,
  selector: 'app-dispatch',
  templateUrl: './dispatch.component.html',
  styleUrl: './dispatch.component.scss',
  imports: [
    FreyaCommonModule,
    CommonModule,
    SharedModule,
    DispatchCardComponent,
    ReactiveFormsModule,
    DispatchEditEventComponent,
    DispatchCrewComponent,
    DispatchChipComponent,
    CdkDropListGroup,
    CdkDropList,
    CdkDrag,
    ButtonGroupModule,
    DatePipe,
    DispatchCrewSettingsComponent,
    DispatchSendScheduleComponent,
    DispatchSendScheduleDialogComponent,
    DispatchOperationsReportComponent,
    QuillEditorComponent,
    PrintDispatchBolsDialogComponent,
    DispatchCalendarRemarksDialogComponent,
    OverlayPanelModule,
    ButtonModule,
    DividerModule,
    ContextMenuModule,
    ProgressBarModule,
    NavigatorStatusComponent,
],
})
export class DispatchComponent implements OnInit, OnDestroy, AfterViewChecked {
  private events$ = this.store.select(selectRouteGroupsWithMetrics);
  private eventsLoaded$ = this.store.select(selectEventsLoaded);

  /** One-shot completion signal for a refresh request: connects before the
   *  caller dispatches so no loaded transition slips past, and replays a
   *  fast completion to the bar's (possibly later) subscription — otherwise
   *  skip(1) could eat a finished fetch and spin for the 20s valve. */
  private refreshDone(): Observable<boolean> {
    const done$ = this.eventsLoaded$.pipe(
      skip(1),
      filter(Boolean),
      take(1),
      shareReplay({ bufferSize: 1, refCount: false }),
    );
    done$.subscribe();
    return done$;
  }
  conflictingEvents$ = this.store.select(selectConflictingEvents);
  areEventRequirementsSatisfied$ = this.store.select(selectAreEventRequirementsSatisfied);

  public isEditCrewRateDialogOpen$ = this.store.select(selectIsEditRateDialogOpen);
  public selectedUserForSalaryEdit$ = this.store.select(selectSelectedUserForRateEdit);
  public filteredCrewCount$ = this.store.select(selectFilteredCrewCount);
  public isSendScheduleDialogOpen$ = this.store.select(selectIsSendScheduleDialogOpen);
  public isCalendarRemarksDialogOpen$ = this.store.select(dispatchCalendarRemarksDialogFeature.selectIsOpen);

  public assigningCrewWithAI$ = this.store.select(selectAssignCrewWithAILoading);
  public assignCrewInfeasibilityReasons$ = this.store.select(selectAssignCrewInfeasibilityReasons);
  public isAssignCrewDialogOpen$ = this.store.select(selectIsAssignCrewDialogOpen);
  aiAssignCrewEnabled$ = this.store.select(selectFeature('ai-assign-crew'));
  public assignCrewProgress = 0;
  public assignCrewProgressText = 'Preparing...';
  public eventCountForAssign = 0;
  private assignCrewProgressTimer?: any;

  public canViewCalendarRemarks$ = this.permissionService.watchPermission('config.set');

  // Pending changes
  public hasPendingChanges$ = this.store.select(selectHasPendingChanges);
  public pendingChangeCount$ = this.store.select(selectPendingChangeCount);
  public isSavingChanges$ = this.store.select(selectIsSavingChanges);
  /** Autosave indicator: rendered inline next to the refresh button (#18). */
  public bannerExpanded = false;
  /** Unix ms of the last successful events fetch — for the refresh tooltip. */
  public lastEventsLoadedAt$ = this.store.select(selectLastEventsLoadedAt);

  /** Live websocket status ('connected' = subscribed to server pushes). */
  public connectionStatus$ = this.graphqlModule.connectionStatus.asObservable();

  /** Calendar remark for the currently viewed date (Ray: show on dispatch too). */
  public calendarRemark$: Observable<{ text: string; severity: string }[]>;
  /** Fires when calendar remarks change (dialog save) — reload the banner. */
  private calendarRemarkReload$ = new Subject<void>();

  /**
   * Seconds until the debounced autosave fires (autosave debounce = 5s after
   * the last pending change). Null when nothing is queued, autosave is off,
   * or a save is already in flight. Ticks every second.
   */
  public autosaveCountdown$: Observable<number | null> = combineLatest([
    this.store.select(selectLastPendingChangeAt),
    this.store.select(selectPendingChanges),
    this.store.select(selectAutosaveEnabled),
    this.store.select(selectIsSavingChanges),
    interval(1000).pipe(startWith(0)),
  ]).pipe(
    map(([lastPendingChangeAt, changes, autosave, saving]) => {
      if (!lastPendingChangeAt || saving || !autosave || changes.length === 0) return null;
      const elapsedSeconds = Math.floor((Date.now() - lastPendingChangeAt) / 1000);
      const remaining = 5 - elapsedSeconds;
      return remaining > 0 ? remaining : 0;
    }),
  );

  /** Tooltip body for the refresh button: live status + last data refresh. */
  public refreshTooltip$ = combineLatest([
    this.connectionStatus$,
    this.lastEventsLoadedAt$,
  ]).pipe(
    map(([status, loadedAt]) => {
      const live = status === 'connected' ? 'Live (subscribed)' : 'Offline (not receiving updates)';
      const last = loadedAt
        ? `Last updated ${dayjs(loadedAt).format('h:mm:ss A')}`
        : 'Never refreshed';
      return `${live} — ${last}`;
    }),
  );

  // Autosave
  public autosaveEnabled$ = this.store.select(selectAutosaveEnabled);
  public autosaveDisabledReason$ = this.store.select(selectSaveError).pipe(
    filter((error) => !!error),
  );
  private readonly AUTOSAVE_KEY = 'dispatch-autosave-enabled';
  /**
   * #7283 C: per-user (browser-local) Event Notes collapse state. The
   * localStorage key is namespaced by the AUTHENTICATED account (CodeRabbit
   * security note) so one account's collapse state or personal notes can
   * never surface for another on a shared browser.
   */
  private readonly NOTES_EXPANDED_KEY = dispatchStorageKey('dispatch-event-notes-expanded');
  /** #7283 D: notes typed in the send dialog, keyed by crew user id. */
  private sendDialogCrewNotes: Record<string, string> = {};
  /** #7283 C: the day currently on the board (YYYY-MM-DD) for event/day keys. */
  private viewedDay = '';

  public events: RouteGroupWithMetrics[] = [];
  public eventsLoaded: boolean = false;
  /**
   * Sticky "has loaded at least once" flag. Background refreshes (live
   * subscription, save-success reload) must not flip the whole board into a
   * skeleton loading state — that is disruptive when dispatchers are reading
   * or dragging rows. The table stays mounted and rows swap in place when
   * fresh data lands; the skeleton only shows before the first-ever load.
   */
  private hasLoadedOnce: boolean = false;
  
  sendScheduleItems: MenuItem[] = [];
  assignCrewItems: MenuItem[] = [];
  sidebarVisible: boolean = true;
  showReportPreview: boolean = false;
  crewContextMenuItems: MenuItem[] = [];
  @ViewChild('crewContextMenu') crewContextMenu!: ContextMenu;
  @ViewChild('gearMenu') gearMenu!: any;
  
  readonly groupByOptions = GROUP_BY_OPTIONS;
  readonly eventStatusOptions = EVENT_STATUS_OPTIONS;

  editEventDialogRef: DynamicDialogRef | undefined;
  public visible: boolean = false;
  public isSendScheduleDialogVisible: boolean = false;
  eventUnderEditting: DispatchEvent = null;

  // Copy for Chat: Job details and distance calculations
  private jobDetailsMap = new Map<string, JobDetailsV2Fragment>();
  private calculatedDistancesMap = new Map<string, CalculateDistanceOutput>();
  private distanceUnits: 'metric' | 'imperial' = environment.defaultUnits as 'metric' | 'imperial';
  private timezone: string;
  private isCopyingSchedule = false;

  public filterEventsForm = new FormGroup({
    date: new FormControl<Date>(new Date()),
    groupBy: new FormControl<DispatchFilterOption<DispatchGroupOptions>>(
      this.groupByOptions.find(o => o.label === DispatchGroupOptions.Route) || this.groupByOptions[0]
    ),
    eventStatus: new FormControl<DispatchFilterOption<DispatchEventStatusOptions>>(this.eventStatusOptions[0]),
  });

  DispatchGroupOptions = DispatchGroupOptions;
  DispatchActions = DispatchActions;
  DispatchCalendarRemarksDialogActions = DispatchCalendarRemarksDialogActions;
  /** Exposed to the template: the route chip must not render a Start Time /
   *  Status grouping key as a route name (CodeRabbit). */
  activeGroupBy: DispatchGroupOptions = DispatchGroupOptions.Route;

  private subs = new SubSink();
  private isCrewSettingsOpen = false;
  private controlsConfig: ScheduleControlsConfig;

  /**
   * The schedule page's shared controls bar is the single date knob now; the
   * bar writes its date here and the form's valueChanges pipeline (setDispatch
   * date + URL persist) does the rest. Same-day no-ops are skipped so the
   * init-time loadEvents query isn't duplicated.
   */
  private controlsDateEffect = effect(() => {
    const d = this.controls.date();
    const current = this.filterEventsForm.controls.date.value;
    if (!d || (current && dayjs(current).isSame(d, 'day'))) {
      return;
    }
    this.filterEventsForm.controls.date.setValue(d);
  });

  @HostListener('window:keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    if (this.visible || this.isSendScheduleDialogVisible) {
      return;
    }

    const target = event.target as HTMLElement;
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
      return;
    }

    if (this.isCrewSettingsOpen) {
      if (event.key === 'ArrowLeft') {
        this.previousCrewMember();
      } else if (event.key === 'ArrowRight') {
        this.nextCrewMember();
      }
    }
  }

  constructor(
    public store: Store,
    public dialogService: DialogService,
    private router: Router,
    private route: ActivatedRoute,
    private brandingService: BrandingService,
    private detailsHelper: DetailsHelperService,
    private messageService: MessageService,
    private jobsV3PageGQL: JobsV3PageGQL,
    private calculateDistanceGQL: CalculateDistanceGQL,
    private timezoneHelper: TimezoneHelperService,
    private controls: ScheduleControlsService,
    private dayEventsUpdatedGQL: DayEventsUpdatedGQL,
    private permissionService: PermissionService,
    private mutateService: FreyaMutateService,
    private printBolService: PrintBolService,
    private updateJobGQL: UpdateJobGQL,
    private graphqlModule: GraphQLModule,
    private artifactService: ArtifactService,
    private viewDatesGQL: ViewDatesGQL,
  ) {
    // #7283 D: the send dialog already mirrors each keystroke into the store;
    // subscribe so notes typed there render inline under the crew chip
    // immediately (per ruling: notes stay authored in the dialog).
    this.subs.sink = this.store.select(selectSendScheduleCrewNotes)
      .subscribe((notes) => { this.sendDialogCrewNotes = notes || {}; });

    // #7283 C scoping (CodeRabbit): collapse state keys include the viewed
    // day — a multi-day event keeps one day's collapse separate from the
    // others. Track the date the board currently shows.
    this.subs.sink = this.store.select(selectDispatchDate)
      .subscribe((date) => {
        this.viewedDay = date ? dayjs(date).format('YYYY-MM-DD') : '';
      });

    // Calendar remark for the viewed date — re-fetches whenever the remark
    // reload trigger fires (dialog save) or the date/zone changes.
    this.calendarRemark$ = combineLatest([
      this.calendarRemarkReload$.pipe(startWith(0)),
      this.store.select(selectDispatchDate),
      this.brandingService.currentZone(),
    ]).pipe(
      switchMap(([, dispatchDate, zone]) => {
        const date = dispatchDate as Date | null;
        if (!date) return of(null);
        const dateStr = dayjs(date).format('YYYY-MM-DD');
        return this.viewDatesGQL.fetch(
          { startDate: dateStr, endDate: dateStr, zone: (zone as any)?.zoneId },
          { fetchPolicy: 'network-only' },
        ).pipe(
          map((res) => {
            const remarks = (res.data?.viewDates as any)?.[0]?.remarks ?? [];
            return remarks.length
              ? remarks.map((r: any) => ({ text: r.text as string, severity: (r.severity || 'info') as string }))
              : [];
          }),
          catchError(() => of(null)),
        );
      }),
    );
  }

  ngOnInit(): void {
    // Register the shared schedule-page controls-bar config: the date lives
    // in the bar above the tabs; this tab's gear opens the dispatch block
    // menu overlay, and refresh re-runs the hard refresh. Assign Crew /
    // Send schedule moved from the header into the bar as tab actions.
    // watchControlsActions() is the ONLY registration path (CodeRabbit):
    // its synchronous first emission seeds mode/gear/refresh with real
    // actions and its later emissions keep them fresh.
    this.watchControlsActions();
    this.initAutosave();
    this.watchEventSelectors();
    this.loadEvents();
    this.watchZoneChange();
    this.watchDateChange();
    this.watchGroupByChanges();
    this.watchEventStatusChange();
    this.watchEventUpdates();
    // Reload the calendar-remark banner after the remarks dialog closes
    // (covers save + cancel — a re-fetch is cheap and always correct).
    this.subs.sink = this.isCalendarRemarksDialogOpen$.pipe(
      skip(1),
      filter((open) => !open),
    ).subscribe(() => this.calendarRemarkReload$.next());
    // Get timezone for formatting arrival windows and durations
    this.timezone = this.timezoneHelper.getCurrentTimezone();

    // Determine distance units from system settings
    this.store.select(selectSystemDetails).pipe(take(1)).subscribe(systemDetails => {
      if (systemDetails?.country) {
        const jurisdiction = jurisdictions.find(j => j.country === systemDetails.country);
        if (jurisdiction?.units) {
          this.distanceUnits = jurisdiction.units;
        }
      }
    });

    this.subs.sink = this.isEditCrewRateDialogOpen$.subscribe((isOpen) => {
      this.isCrewSettingsOpen = isOpen;
    });

    this.sendScheduleItems = [
      {
        label: 'Print Operations Report',
        icon: 'pi pi-print',
        command: () => { this.showReportPreview = true; }
      },
      {
        label: 'Print BOLs',
        icon: 'pi pi-print',
        command: () => this.openPrintBolsDialog()
      },
      {
        label: 'Copy for Spreadsheet',
        icon: 'pi pi-table',
        command: () => this.copyScheduleHtml()
      },
      {
        label: 'Copy for Chat',
        icon: 'pi pi-comments',
        command: () => this.copyScheduleText()
      }
    ];

    this.assignCrewItems = [
      {
        label: 'Clear Crew',
        icon: 'pi pi-user-minus',
        command: () => this.unassignAllUnlockedCrew()
      }
    ];
  }

  assignCrewWithAI() {
    // Count events for the loading dialog
    this.eventCountForAssign = (this.events || [])
      .reduce((sum, group) => sum + (group.events?.length || 0), 0);
    this.assignCrewProgress = 0;
    this.assignCrewProgressText = 'Preparing...';
    this.startAssignCrewProgress();
    this.store.dispatch(DispatchActions.assignCrewMembersWithAIClicked());
  }

  private startAssignCrewProgress(): void {
    if (this.assignCrewProgressTimer) clearInterval(this.assignCrewProgressTimer);
    const steps = [
      { progress: 15, text: 'Loading events...' },
      { progress: 30, text: 'Analyzing routes...' },
      { progress: 50, text: 'Finding available crew...' },
      { progress: 70, text: 'Optimizing assignments...' },
      { progress: 85, text: 'Applying to server...' },
    ];
    let stepIdx = 0;
    this.assignCrewProgressTimer = setInterval(() => {
      if (stepIdx < steps.length) {
        this.assignCrewProgress = steps[stepIdx].progress;
        this.assignCrewProgressText = steps[stepIdx].text;
        stepIdx++;
      } else if (this.assignCrewProgress < 95) {
        this.assignCrewProgress += 1;
      }
    }, 800);
  }

  private assignCrewProgressTimeout?: any;

  private stopAssignCrewProgress(): void {
    if (this.assignCrewProgressTimer) {
      clearInterval(this.assignCrewProgressTimer);
      this.assignCrewProgressTimer = undefined;
    }
    this.assignCrewProgress = 100;
    this.assignCrewProgressText = 'Done!';
    this.assignCrewProgressTimeout = setTimeout(() => {
      this.assignCrewProgress = 0;
      this.assignCrewProgressTimeout = undefined;
    }, 1000);
  }

  dismissAssignCrewResult() {
    this.store.dispatch(DispatchActions.assignCrewResultDismissed());
  }

  unassignAllUnlockedCrew() {
    this.store.dispatch(DispatchActions.unassignAllUnlockedCrew());
  }

  public openEditDispatchEventDialog(event: DispatchEvent) {
    this.eventUnderEditting = event;
    this.visible = true;
  }

  public openSendScheduleDialog() {
    this.store.dispatch(DispatchActions.sendScheduleDialogOpened());
  }

  public onOpsManagersChange(selectedIds: string[]): void {
    // Ops managers are now events on the dispatch board.
    // Compare with currently assigned ops managers and create/remove events.
    firstValueFrom(this.store.select(selectSelectedOpsManagerIds)).then((currentIds) => {
      const toAdd = selectedIds.filter((id) => !currentIds.includes(id));
      const toRemove = currentIds.filter((id) => !selectedIds.includes(id));

      for (const userId of toAdd) {
        this.store.dispatch(DispatchActions.opsManagerEventCreated({
          input: {
            eventId: uuid(),
            userId,
            start: this.defaultOpsManagerStart(),
            end: this.defaultOpsManagerEnd(),
            selectedDate: this.filterEventsForm.controls.date.value || new Date(),
          },
        }));
      }

      for (const userId of toRemove) {
        // Find the ops-manager event for this user and delete it
        firstValueFrom(this.store.select(selectOpsManagerEvents)).then((opsEvents) => {
          const eventToDelete = opsEvents.find((e) => e.crew.some((c) => c.user.id === userId));
          if (eventToDelete) {
            this.store.dispatch(DispatchActions.deleteCrewBookOffEvent({ bookOffId: eventToDelete.event.id }));
          }
        });
      }
    });
  }

  public onOpsManagerDayNoteChange(_dayNote: string): void {
    // Day note is now stored on the ops-manager event's description.
    // This will be handled via event edit in a future iteration.
    // For now, the note is read from the first ops-manager event's description.
  }

  private defaultOpsManagerStart(): number {
    const date = this.filterEventsForm.controls.date.value || new Date();
    return dayjs(date).startOf('day').add(7, 'hours').unix();
  }

  private defaultOpsManagerEnd(): number {
    const date = this.filterEventsForm.controls.date.value || new Date();
    return dayjs(date).startOf('day').add(17, 'hours').unix();
  }

  /**
   * Get all unique crew members across all events in a route group.
   * Used to show crew chips in the drop zone above the events.
   */
  /**
   * Get crew count for a route group (used for showing delete button when empty).
   */
  public getRouteCrewCount(group: { group: string; events: DispatchEvent[]; crew?: any[] }): number {
    return group.crew?.length || 0;
  }

  private parseCrewRequirement(raw: any): { crewLeads: number; crewMembers: number; opsPeople: number } | undefined {
    if (!raw) return undefined;
    try {
      return typeof raw === 'string' ? JSON.parse(raw) : raw;
    } catch {
      return undefined;
    }
  }

  public getSpecialCrewReqText(group: { group: string; events: DispatchEvent[] }): string {
    const event = group.events?.[0];
    if (!event) return '';
    const meta = event.event?.metadata as any;
    const req = this.parseCrewRequirement(meta?.crewRequirement);
    if (!req) return '';
    const parts: string[] = [];
    if (req.crewLeads > 0) parts.push(`${req.crewLeads}L`);
    if (req.crewMembers > 0) parts.push(`${req.crewMembers}M`);
    if (req.opsPeople > 0) parts.push(`${req.opsPeople} ops`);
    return parts.length ? `Need: ${parts.join(' · ')}` : '';
  }

  // ── Autosave ─────────────────────────────────────────────────────────────

  private initAutosave(): void {
    const stored = localStorage.getItem(this.AUTOSAVE_KEY);
    const enabled = stored === null ? true : stored === 'true';
    this.store.dispatch(DispatchActions.setAutosaveEnabled({ enabled }));

    // Disable autosave on offline
    window.addEventListener('offline', () => {
      this.store.dispatch(DispatchActions.setAutosaveEnabled({ enabled: false }));
    });
    window.addEventListener('online', () => {
      const storedVal = localStorage.getItem(this.AUTOSAVE_KEY);
      if (storedVal !== 'false') {
        this.store.dispatch(DispatchActions.setAutosaveEnabled({ enabled: true }));
      }
    });
  }

  public toggleAutosave(enabled: boolean): void {
    localStorage.setItem(this.AUTOSAVE_KEY, String(enabled));
    this.store.dispatch(DispatchActions.setAutosaveEnabled({ enabled }));
  }

  /**
   * Additional contacts on the job's customer (Ray: show on dispatch).
   * Read off the wrapped event's customer user; empty when there is no
   * customer or the job has none.
   */
  public getAdditionalContacts(event: DispatchEvent): {
    name?: string;
    relationship?: string;
    phone?: string;
    email?: string;
  }[] {
    return ((event.customer?.user as any)?.additionalContacts || []) as any;
  }

  /** Tooltip text for an additional-contact chip (phone + email). */
  public contactTooltip(contact: { phone?: string; email?: string }): string {
    return [contact.phone, contact.email].filter(Boolean).join(' · ');
  }

  /**
   * Get crew members that are on this event but NOT on all events in the route.
   * These show on the mini card instead of the route-level crew row.
   */
  public getEventOnlyCrew(
    event: DispatchEvent,
    group: { group: string; events: DispatchEvent[]; sharedCrewIds?: Set<string> },
  ): { name: string; isCrewLead: boolean; isDriver: boolean; userId: string; dragData: any }[] {
    const sharedIds = group?.sharedCrewIds;
    if (!sharedIds) return [];
    return event.crew
      .filter((c) => c.user?.id && !sharedIds.has(c.user.id))
      .map((c) => ({
        name: c.name,
        isCrewLead: c.role === EventAttendeeRoles.crewLead || c.role === EventAttendeeRoles.assistantCrewLead,
        isDriver: c.role === EventAttendeeRoles.driver,
        userId: c.user.id,
        dragData: {
          attendee: {
            user: { id: c.user.id },
            name: c.name,
            role: c.role,
          },
        },
      }));
  }

  /**
   * Remove a crew member from a specific event (not the whole route).
   */
  /**
   * Click on a crew chip's pencil (or chip itself) — open the person's
   * settings dialog. Resolves the full user from the board's events.
   */
  public onCrewChipEdit(
    member: { userId: string; name: string; role?: string; isCrewLead?: boolean; isDriver?: boolean },
  ): void {
    let user: any = null;
    for (const group of this.events) {
      for (const event of group.events || []) {
        const found = (event.crew || []).find((c) => c.user?.id === member.userId);
        if (found?.user) { user = found.user; break; }
      }
      if (user) break;
    }
    if (user) {
      this.store.dispatch(DispatchActions.editCrewSettingsUserSelected({ user }));
    }
  }

  public onCrewRightClick(
    $event: MouseEvent,
    member: { userId: string; name: string; role?: string; isCrewLead?: boolean; isDriver?: boolean },
    context: { type: 'route' | 'event'; event?: DispatchEvent; group?: any },
  ): void {
    $event.preventDefault();
    $event.stopPropagation();

    const isLocked = context.type === 'event' && context.event
      ? (context.event.crew.find((c) => c.user.id === member.userId)?.locked ?? false)
      : false;

    const groupEvents = context.type === 'route'
      ? (context.group?.events || [])
      : [];

    this.crewContextMenuItems = [
      {
        label: 'Edit',
        icon: 'pi pi-pencil',
        command: () => {
          const user = context.event?.crew.find((c) => c.user.id === member.userId)?.user
            || groupEvents[0]?.crew?.find((c) => c.user.id === member.userId)?.user;
          if (user) {
            this.store.dispatch(DispatchActions.editCrewSettingsUserSelected({ user }));
          }
        },
      },
      {
        label: isLocked ? 'Unlock' : 'Lock',
        icon: isLocked ? 'pi pi-lock-open' : 'pi pi-lock',
        command: () => this.toggleCrewLock(member, context),
      },
      {
        label: 'Remove',
        icon: 'pi pi-trash',
        command: () => this.removeCrewFromContext(member, context),
      },
      {
        label: 'Remove & Book Off',
        icon: 'pi pi-calendar-times',
        command: () => {
          this.removeCrewFromContext(member, context);
          this.bookOffCrewMember(member);
        },
      },
      ...(context.type === 'route' && groupEvents.length > 1 ? [{
        label: 'Lock to all events on route',
        icon: 'pi pi-lock',
        command: () => this.lockCrewToRoute(member, groupEvents),
      }] : []),
    ];

    this.crewContextMenu.show($event);
  }

  private toggleCrewLock(
    member: { userId: string; name: string; role?: string },
    context: { type: 'route' | 'event'; event?: DispatchEvent; group?: any },
  ): void {
    const event = context.event || context.group?.events?.[0];
    if (!event) return;
    const eventId = event.event.id;
    const role = member.role || event.crew.find((c) => c.user.id === member.userId)?.role || EventAttendeeRoles.crewMember;
    const currentLocked = event.crew.find((c) => c.user.id === member.userId)?.locked ?? false;

    // Lock toggle = remove + re-add with new locked state.
    // Dispatch as removeCrew + addCrew so the save effect persists it.
    // eslint-disable-next-line @ngrx/avoid-dispatching-multiple-actions-sequentially
    this.store.dispatch(DispatchActions.pendingChangeAndOptimisticUpdate({
      change: {
        id: `lockRm-${member.userId}-${eventId}-${Date.now()}`,
        type: 'removeCrew',
        eventId,
        eventName: event.event.title,
        userId: member.userId,
        userName: member.name,
        role,
        fromEvents: [{ eventId, eventName: event.event.title, role }],
      },
      edits: [{
        eventId,
        eventName: event.event.title,
        removeAttendees: [{ user: { id: member.userId }, role } as any],
      }],
    }));
    // eslint-disable-next-line @ngrx/avoid-dispatching-multiple-actions-sequentially
    this.store.dispatch(DispatchActions.pendingChangeAndOptimisticUpdate({
      change: {
        id: `lockAdd-${member.userId}-${eventId}-${Date.now()}`,
        type: 'addCrew',
        eventId,
        eventName: event.event.title,
        userId: member.userId,
        userName: member.name,
        role,
        locked: !currentLocked,
      },
      edits: [{
        eventId,
        eventName: event.event.title,
        addAttendees: [{ user: { id: member.userId }, name: member.name, role, locked: !currentLocked } as any],
      }],
    }));
  }

  private removeCrewFromContext(
    member: { userId: string; name: string; role?: string },
    context: { type: 'route' | 'event'; event?: DispatchEvent; group?: any },
  ): void {
    if (context.type === 'event' && context.event) {
      this.onRemoveCrewFromEvent(context.event, member);
    } else if (context.type === 'route' && context.group) {
      this.onRemoveCrewFromRoute(context.group, member);
    }
  }

  private bookOffCrewMember(member: { userId: string; name: string }): void {
    // Requirement: Book-off from the context menu uses full-day times
    // (00:00-23:59) matching the dispatch-crew component's bookOffUser.
    const dispatchDate = this.filterEventsForm.controls.date.value || new Date();
    const start = dayjs(dispatchDate).startOf('day').unix();
    const end = dayjs(dispatchDate).endOf('day').unix();
    this.store.dispatch(DispatchActions.crewBookOffCreated({
      newBookOff: {
        userId: member.userId,
        selectedDate: dispatchDate,
        selectedTimeBlock: { label: 'All Day', start: 0, end: 86340 },
        description: 'Booked off from Dispatch',
        start,
        end,
        customStartTime: null,
        customEndTime: null,
      },
    }));
  }

  private lockCrewToRoute(
    member: { userId: string; name: string; role?: string },
    events: DispatchEvent[],
  ): void {
    const role = member.role || events[0]?.crew.find((c) => c.user.id === member.userId)?.role || EventAttendeeRoles.crewMember;
    for (const event of events) {
      const isOnEvent = event.crew.some((c) => c.user.id === member.userId);
      if (!isOnEvent) {
        this.store.dispatch(DispatchActions.pendingChangeAndOptimisticUpdate({
          change: {
            id: `lockRoute-${member.userId}-${event.event.id}-${Date.now()}`,
            type: 'addCrew',
            eventId: event.event.id,
            eventName: event.event.title,
            userId: member.userId,
            userName: member.name,
            role,
          },
          edits: [{
            eventId: event.event.id,
            eventName: event.event.title,
            addAttendees: [{ user: { id: member.userId }, name: member.name, role, locked: true } as any],
          }],
        }));
      } else {
        // Already on event — just lock
        this.toggleCrewLock(member, { type: 'event', event });
      }
    }
  }

  public onRemoveCrewFromEvent(
    event: DispatchEvent,
    member: { userId: string; name: string; role?: string },
  ): void {
    const eventId = event.event.id;
    const role = member.role || event.crew.find((c) => c.user.id === member.userId)?.role || EventAttendeeRoles.crewMember;

    this.store.dispatch(DispatchActions.pendingChangeAndOptimisticUpdate({
      change: {
        id: `remove-${member.userId}-${eventId}-${Date.now()}`,
        type: 'removeCrew',
        eventId,
        eventName: event.event.title,
        userId: member.userId,
        userName: member.name,
        role,
        fromEvents: [{ eventId, eventName: event.event.title, role }],
      },
      edits: [{
        eventId,
        eventName: event.event.title,
        removeAttendees: [{
          user: { id: member.userId },
          role,
        } as any],
      }],
    }));
  }

  /**
   * Handle crew drop onto a specific event's mini card.
   */
  public onEventDrop(
    event: CdkDragDrop<DispatchEvent>,
    targetEvent: DispatchEvent,
  ): void {
    if (!event.previousContainer) return;

    const crewData = event.item.data as { attendee: { user: { id: string }; name: string; role: string } };
    const userId = crewData?.attendee?.user?.id;
    const crewName = crewData?.attendee?.name || '';
    if (!userId) return;

    const targetEventId = targetEvent.event.id;

    // If dropping from the same event, do nothing
    if (event.container === event.previousContainer) return;

    // Check if crew is already on the target event
    if (targetEvent.crew.some((c) => c.user.id === userId)) return;

    // Determine source: route crew or another event
    const prevData = event.previousContainer.data as any;
    const prevEventId = prevData?.event?.id;

    const removeEdits = prevEventId
      ? [{
          eventId: prevEventId,
          eventName: prevData?.event?.title || '',
          removeAttendees: [{
            user: { id: userId },
            role: prevData?.crew?.find((c: any) => c.user.id === userId)?.role || EventAttendeeRoles.crewMember,
          } as any],
        }]
      : [];

    this.store.dispatch(DispatchActions.pendingChangeAndOptimisticUpdate({
      change: {
        id: `move-${userId}-${Date.now()}`,
        type: 'moveCrew',
        eventId: targetEventId,
        eventName: targetEvent.event.title,
        userId,
        userName: crewName,
        role: EventAttendeeRoles.crewMember,
        fromEvents: prevEventId
          ? [{
              eventId: prevEventId,
              eventName: prevData?.event?.title || '',
              role: prevData?.crew?.find((c: any) => c.user.id === userId)?.role
                || EventAttendeeRoles.crewMember,
            }]
          : [],
        toEvents: [{ eventId: targetEventId, eventName: targetEvent.event.title }],
      },
      edits: [
        ...removeEdits,
        {
          eventId: targetEventId,
          eventName: targetEvent.event.title,
          addAttendees: [{
            user: { id: userId },
            name: crewName,
            role: EventAttendeeRoles.crewMember,
          } as any],
        },
      ],
    }));
  }

  /**
   * Delete a special block (reserve/admin/ops-manager).
   */
  public deleteBlock(group: { group: string; events: DispatchEvent[] }): void {
    if (!group.events?.length) return;
    for (const event of group.events) {
      this.store.dispatch(DispatchActions.blockDeleted({ eventId: event.event.id }));
    }
  }

  /**
   * Get a summary of common crew across all events in a route group.
   * Shows crew names that appear on all events in the route.
   */
  public getRouteCrewSummary(group: { group: string; events: DispatchEvent[] }): string {
    if (!group.events?.length) return '';

    // Collect crew from all events in this route
    const crewByEvent = group.events.map((e) =>
      e.crew.filter((c) => c.user?.id).map((c) => c.user.id),
    );

    // Find crew that are on ALL events in the route (common crew)
    const commonCrewIds = crewByEvent.reduce((acc, ids) => {
      if (acc === null) return new Set(ids);
      return new Set(ids.filter((id) => acc.has(id)));
    }, null as Set<string> | null);

    if (!commonCrewIds || commonCrewIds.size === 0) return '';

    // Get names
    const allCrew = group.events.flatMap((e) => e.crew);
    const names = Array.from(commonCrewIds)
      .map((id) => allCrew.find((c) => c.user.id === id)?.name)
      .filter(Boolean) as string[];

    return names.join(', ');
  }

  /**
   * Build drag data for a crew chip in the route drop zone.
   * Kept as a method because Angular templates can't parse complex inline object literals.
   */
  /**
   * Open a popup to adjust the time of a special route (ops-manager, reserve, admin).
   * This opens the custom block dialog pre-filled with the event's current
   * name and time, allowing the user to change both.
   */
  public openTimePopup(group: { group: string; events: DispatchEvent[] }): void {
    if (!group.events?.length) return;
    const event = group.events[0];
    const eventType = event.event.type;

    // Load existing crew requirement from event metadata
    const meta = event.event?.metadata as any;
    const parsedReq = this.parseCrewRequirement(meta?.crewRequirement);
    const existingCrewRequirement = parsedReq
        ? { crewLeads: parsedReq.crewLeads || 0, crewMembers: parsedReq.crewMembers || 0, opsPeople: parsedReq.opsPeople || 1 }
        : undefined;

    const dispatchDate = this.filterEventsForm.controls.date.value || new Date();
    this.dialogService.open(CustomBlockDialogComponent, {
      header: 'Edit Block',
      width: '400px',
      data: {
        type: eventType,
        dispatchDate,
        defaultStart: event.event.start,
        defaultEnd: event.event.end,
        existingName: event.event.title,
        existingEventId: event.event.id,
        existingCrewRequirement,
      },
    }).onClose.subscribe((result: {
      name: string; start: number; end: number; delete?: boolean;
      eventId?: string; crewRequirement?: any;
    } | undefined) => {
      if (!result) return;

      if (result.delete && result.eventId) {
        this.store.dispatch(DispatchActions.blockDeleted({ eventId: result.eventId }));
        return;
      }

      // Push an editEvent pending change with crew requirement in metadata
      this.store.dispatch(DispatchActions.pendingChangeAdded({
        change: {
          id: `edit-${event.event.id}-${Date.now()}`,
          type: 'editEvent',
          eventId: event.event.id,
          eventName: event.event.title,
          newTitle: result.name,
          newStart: result.start,
          newEnd: result.end,
          eventData: {
            crewRequirement: result.crewRequirement,
          },
        },
      }));
    });
  }

  /**
   * Remove a crew member from all events in a route.
   */
  public onRemoveCrewFromRoute(
    group: { group: string; events: DispatchEvent[] },
    member: RouteCrewMember,
  ): void {
    const routeEvents = group.events;
    if (!routeEvents?.length) return;

    const edits = routeEvents
      .filter((e) => e.crew.some((c) => c.user.id === member.userId))
      .map((e) => ({
        eventId: e.event.id,
        eventName: e.event.title,
        removeAttendees: [{
          user: { id: member.userId },
          role: e.crew.find((c) => c.user.id === member.userId)?.role || EventAttendeeRoles.crewMember,
        } as any],
      }));

    if (!edits.length) return;

    // Single dispatch: pending change + optimistic update
    this.store.dispatch(DispatchActions.pendingChangeAndOptimisticUpdate({
      change: {
        id: `remove-${member.userId}-${Date.now()}`,
        type: 'removeCrew',
        eventId: edits[0].eventId,
        eventName: edits[0].eventName,
        userId: member.userId,
        userName: member.name,
        role: (edits[0].removeAttendees[0] as any).role,
        fromEvents: edits.map((e) => ({
          eventId: e.eventId,
          eventName: e.eventName,
          role: (e.removeAttendees[0] as any).role,
        })),
      },
      edits,
    }));
  }

  /**
   * Open the first asset in a route group in the right details panel.
   */
  public openAssetInRightPanel(group: { group: string; events: DispatchEvent[] }): void {
    for (const event of group.events) {
      if (event.trucks?.length) {
        this.detailsHelper.open('asset', event.trucks[0]);
        return;
      }
    }
  }

  /**
   * Open job in right panel via details helper.
   */
  public openJobInRightPanel(event: DispatchEvent): void {
    if (event.event.job) {
      this.detailsHelper.open('job', event.event.job);
    } else {
      this.openEditDispatchEventDialog(event);
    }
  }

  /**
   * Open event details in the details panel.
   */
  public openEventDetails(event: DispatchEvent): void {
    this.detailsHelper.open('calendar-event', event.event);
  }

  /**
   * Print BOL for an event.
   */
  public printBol(event: DispatchEvent): void {
    if (event.event && event.event.job) {
      this.printBolService.printEvents([{
        eventId: event.event.id,
        jobId: event.event.job.id,
      }]);
    }
  }

  /**
   * Clear crew for an event.
   */
  public clearCrewForEvent(event: DispatchEvent): void {
    const removeAttendees = event.crew.map(c => ({
      user: c.user,
      role: c.role,
    }));
    if (removeAttendees.length) {
      this.store.dispatch(DispatchActions.updateCrew({
        edits: [{
          eventId: event.event.id,
          eventName: event.customer.name,
          removeAttendees,
        }],
      }));
    }
  }

  /**
   * Open the mini card actions menu (overlay panel).
   */
  public openMiniCardMenu(_event: Event, _dispatchEvent: DispatchEvent): void {
    // The overlay panel is controlled via template reference variable
  }

  // ── Ops summary notes ────────────────────────────────────────────────────
  private opsNotesSubjects = new Map<string, Subject<string>>();
  private opsNotesValues = new Map<string, string>();
  private opsNotesInitialized = new Set<string>();
  private readonly OPS_NOTES_KEY = 'calculatorOutput__opsNotes';

  public trackByEventId(_index: number, event: DispatchEvent): string {
    return event.event?.id || _index.toString();
  }

  public trackByGroupId(_index: number, group: any): string {
    return group.group || _index.toString();
  }

  public getOpsNotes(event: DispatchEvent): string {
    const eventId = event.event?.id;
    // Prefer local unsaved value if it exists (being typed)
    if (eventId && this.opsNotesValues.has(eventId)) {
      return this.opsNotesValues.get(eventId)!;
    }
    const metadata = event.event?.job?.metadata as any;
    const val = metadata?.[this.OPS_NOTES_KEY];
    return typeof val === 'string' ? val : '';
  }

  public onOpsNotesFocus(event: DispatchEvent, textarea: HTMLTextAreaElement): void {
    const eventId = event.event?.id;
    if (!eventId) return;
    if (!this.opsNotesValues.has(eventId)) {
      this.opsNotesValues.set(eventId, textarea.value);
    }
  }

  public onOpsNotesInput(event: DispatchEvent, $event: Event, textarea: HTMLTextAreaElement): void {
    const value = textarea.value;
    const eventId = event.event?.id;
    if (!eventId) return;

    this.opsNotesValues.set(eventId, value);

    if (!this.opsNotesSubjects.has(eventId)) {
      const subject = new Subject<string>();
      subject.pipe(debounceTime(300)).subscribe((val) => {
        this.store.dispatch(DispatchActions.pendingChangeAdded({
          change: {
            id: `opsNotes-${eventId}-${Date.now()}`,
            type: 'editEvent',
            eventId,
            eventName: event.event.title,
            newTitle: event.event.title,
            eventData: { opsNotes: val, jobId: event.event?.job?.id },
          },
        }));
      });
      this.opsNotesSubjects.set(eventId, subject);
    }
    this.opsNotesSubjects.get(eventId)!.next(value);
  }

  // ── Event notes (per-event, mover-facing — saved to event metadata.eventNotes) ──
  // Ray: the dispatch card editor edits the SAME store the workorders page's
  // Event Notes section writes (metadata_eventNotes as a serialized Quill
  // delta). It previously wrote job.crewSummary, which leaked what dispatchers
  // typed here into the job page's "Workorder Summary".
  private crewNotesSubjects = new Map<string, Subject<Delta>>();
  private crewNotesDeltas = new Map<string, Delta>();
  private crewNotesInitialized = new Set<string>();
  /** Shared empty delta — one stable reference instead of a fresh instance per call. */
  private readonly emptyCrewNotesDelta = new Delta();

  // Formatting options copied from the MoveRight Workorders Event Notes
  // editor (Ray: Dispatch and Workorders Event Notes had different
  // formatting options — parity, issue #6983) plus the client account's
  // Activity "Add Attachment" (📎 files + inline pictures), stored
  // event-scoped so they only ever show on the event they were attached to.
  public crewNotesQuillModules: QuillModules = {
        toolbar: [
            [{ header: [1, 2, 3, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ color: [] }, { background: [] }],
            [{ size: ['small', false, 'large', 'huge'] }],
            [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        ],
        attachmentToolbar: true,
        imageUpload: true,
  };

  /** Personal note a crew member received with their schedule send
   *  (persisted onto event metadata by the send-schedule-to-crew backend;
   *  Ray #6983: visible directly on Dispatch, not only in the dialog). */
  public getCrewPersonalNote(event: DispatchEvent, userId: string | undefined): CrewPersonalNote | null {
    return getCrewPersonalNote(event?.event?.metadata, userId);
  }

  /**
   * #7283 D: the personal note to show inline under a crew member.
   *
   * The note typed in the send dialog wins while present (it must appear
   * immediately, before any send); once sent, the backend stamp on the event
   * (`metadata.personalNotes`) is the persisted truth and keeps showing after
   * reloads. Both are client-visible only; no inheritance from other events.
   */
  public getInlineCrewPersonalNote(event: DispatchEvent, userId: string | undefined): string | null {
    const typed = userId ? this.sendDialogCrewNotes[userId] : undefined;
    if (typeof typed === 'string' && typed.trim()) { return typed.trim(); }
    return this.getCrewPersonalNote(event, userId)?.note ?? null;
  }

  /**
   * Personal notes for SHARED route crew members on ONE event's card
   * (CodeRabbit round 2: shared crew aren't in eventOnlyCrew, so the event
   * cards couldn't show their notes — and any note that isn't on the route's
   * first event was invisible). Each shared member with a note for THIS
   * event becomes one rendered line; the typed-in-dialog draft wins while
   * present (same precedence as the per-event chips).
   */
  public getSharedCrewNoteLines(
    group: RouteGroupWithMetrics | undefined,
    event: DispatchEvent,
  ): { userId: string; name: string; note: string }[] {
    const lines: { userId: string; name: string; note: string }[] = [];
    for (const member of group?.crew || []) {
      const note = this.getInlineCrewPersonalNote(event, member.userId);
      if (typeof note === 'string' && note.trim()) {
        lines.push({ userId: member.userId, name: member.name, note });
      }
    }
    return lines;
  }

  /** Angular trackBy for the shared-note rows — identity is the crew user
   *  id, so change detection doesn't rebuild the DOM lines every pass. */
  public trackBySharedNoteLine(_index: number, line?: { userId: string }): string {
    return line?.userId ?? '';
  }

  // ── #7283 C: Event Notes collapse state (per user, browser-local) ────────

  private notesExpandedLoaded = false;
  private notesExpanded: Record<string, boolean> = {};

  /** Collapse key: per event AND per day (a multi-day event is one id on several days). */
  private notesKey(eventId: string): string {
    return this.viewedDay ? `${this.viewedDay}:${eventId}` : eventId;
  }

  /** Is this event's Event Notes section expanded? Unstored events default to expanded. */
  public isEventNotesExpanded(eventId: string | undefined): boolean {
    if (!eventId) { return true; }
    if (!this.notesExpandedLoaded) {
      try {
        const raw = localStorage.getItem(this.NOTES_EXPANDED_KEY);
        const parsed = raw ? JSON.parse(raw) : null;
        // Valid JSON `null`/arrays would crash indexing below — accept only
        // a plain object (CodeRabbit stability note).
        this.notesExpanded = parsed && typeof parsed === 'object' && !Array.isArray(parsed)
          ? parsed : {};
      } catch {
        this.notesExpanded = {};
      }
      this.notesExpandedLoaded = true;
    }
    return this.notesExpanded[this.notesKey(eventId)] ?? true;
  }

  /** Toggle (and persist) the collapse state of an event's Event Notes section. */
  public toggleEventNotes(eventId: string): void {
    const key = this.notesKey(eventId);
    this.notesExpanded[key] = !this.isEventNotesExpanded(eventId);
    try {
      localStorage.setItem(this.NOTES_EXPANDED_KEY, JSON.stringify(this.notesExpanded));
    } catch { /* localStorage might be full or unavailable */ }
  }

  public getCrewNotesDelta(event: DispatchEvent): Delta {
    const eventId = event.event?.id;
    if (!eventId) return this.emptyCrewNotesDelta;
    // Memoize: [ngModel] must receive the SAME reference on every change
    // detection cycle, otherwise quill-editor's writeValue re-runs
    // setContents each cycle (DOM mutation → CD → new Delta → repeat) and
    // wedges the page in an infinite loop.
    if (this.crewNotesDeltas.has(eventId)) {
      return this.crewNotesDeltas.get(eventId)!;
    }
    // OPS tasks have no job — their notes live on the event's
    // metadata_dayNotes (same storage the ops-manager day notes use).
    if (event.event?.type === 'ops-task') {
      return this.getDayNotesDelta(event);
    }
    const raw = (event.event?.metadata as any)?.eventNotes;
    let parsed: Delta = this.emptyCrewNotesDelta;
    if (raw) {
      try {
        const delta = typeof raw === 'string' ? JSON.parse(raw) : raw;
        if (delta?.ops) parsed = new Delta(delta.ops);
      } catch {
        // Legacy plain-text content — wrap it so the words survive instead
        // of being wiped out by the next edit (same fallback the workorders
        // page's getNotesDelta uses).
        parsed = typeof raw === 'string'
          ? new Delta().insert(raw)
          : this.emptyCrewNotesDelta;
      }
    }
    this.crewNotesDeltas.set(eventId, parsed);
    return parsed;
  }

  /**
   * True when the event notes editor has content — drives the floating
   * label's "filled" state. Reads the memoized delta (populated by
   * getCrewNotesDelta, which the template binding calls on the same CD pass)
   * so this never re-parses the metadata.
   */
  public hasCrewNotes(event: DispatchEvent): boolean {
    const delta = this.getCrewNotesDelta(event);
    if (!delta?.ops) return false;
    // Empty quill docs still carry a single { insert: '\n' } op.
    return delta.ops.some(
      (op: any) => typeof op.insert === 'string' && op.insert.trim() !== '',
    );
  }

  /**
   * Files attached through the Event Notes' 📎 button (Ray: "Add Attachment"
   * inside the Event Notes formatting tools — must be event-scoped, #6983).
   *
   * Authoritative while pending — seeded from the event's server metadata
   * (`metadata.eventAttachments`) the first time it is touched, then kept in
   * sync as uploads land / files are removed. Reuses the client account's
   * Activity attachment wheel (artifacts + signed-policy upload).
   */
  private eventNotesAttachments = new Map<string, EventNotesAttachment[]>();

  public onCrewNotesEditorCreated(editor: Quill, event: DispatchEvent): void {
    const attachmentModule = editor.getModule('attachmentToolbar') as
      | {
          onFilesSelected?: (files: File[]) => void;
          onFilesRejected?: (rejected: { file: File; reason: string }[]) => void;
        }
      | undefined;
    if (!attachmentModule) return;

    attachmentModule.onFilesRejected = (rejected) => {
      for (const { file, reason } of rejected) {
        this.messageService.add({
          severity: 'error',
          summary: 'File not allowed',
          detail: reason === 'size'
            ? `"${file.name}" exceeds the size limit`
            : `"${file.name}" is not a supported file type`,
        });
      }
    };

    attachmentModule.onFilesSelected = (files) => {
      this.onEventNotesFilesSelected(event, files);
    };

    // Inline pictures (Activity-parity): upload then insert into the notes
    // delta at the caret.
    const imageUploadModule = editor.getModule('imageUpload') as
      | {
          onImageRejected?: (file: File, reason: string) => void;
          onImageSelected?: (file: File, insertImage: (url: string) => void) => void;
        }
      | undefined;
    if (imageUploadModule) {
      imageUploadModule.onImageRejected = (file, reason) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Image not allowed',
          detail: reason === 'size'
            ? `"${file.name}" exceeds the size limit`
            : `"${file.name}" is not a supported image type`,
        });
      };
      imageUploadModule.onImageSelected = (file, insertImage) => {
        this.uploadAndInsertEventNotesImage(file, insertImage);
      };
    }
  }

  /**
   * Inline pictures (Activity-parity): upload as an artifact scoped to event
   * notes, then drop the URL into the notes delta at the caret.
   */
  private async uploadAndInsertEventNotesImage(file: File, insertImage: (url: string) => void): Promise<void> {
    try {
      const result = await firstValueFrom(
        this.artifactService.createArtifact([{
          contentType: file.type,
          fileSize: file.size,
          name: file.name,
          namespace: 'event-inline-image',
          public: true,
        }]),
      );
      const artifact = result.data.createArtifacts.artifacts[0];
      if (!artifact) throw new Error('No artifact returned from server');
      const policy = JSON.parse(artifact.signedPolicy);
      try {
        await firstValueFrom(this.artifactService.uploadFile(file as any, policy));
      } catch (uploadError) {
        // createArtifact succeeded but the upload did not — the record would
        // linger with no inserted image (CodeRabbit). Clean it up.
        try {
          await firstValueFrom(this.artifactService.deleteArtifacts([artifact.id]));
        } catch (cleanupError) {
          console.error('Artifact cleanup failed after failed image upload', artifact.id, cleanupError);
        }
        throw uploadError;
      }
      insertImage(artifact.url);
    } catch {
      this.messageService.add({
        severity: 'error',
        summary: 'Image upload failed',
        detail: `Could not upload "${file.name}"`,
      });
    }
  }

  /** The event's attachments — server metadata (JSON-string form tolerated) merged with local pending changes. */
  public getEventNotesAttachments(event: DispatchEvent): EventNotesAttachment[] {
    const eventId = event.event?.id ?? '';
    const rawServer = (event.event?.metadata as any)?.eventAttachments;
    let fromServer: EventNotesAttachment[] = [];
    if (rawServer) {
      try {
        const parsed = typeof rawServer === 'string' ? JSON.parse(rawServer) : rawServer;
        fromServer = Array.isArray(parsed)
          ? parsed.filter((a: any): a is EventNotesAttachment =>
              !!a && typeof a === 'object' && typeof a.artifactId === 'string' && typeof a.name === 'string')
          : [];
      } catch {
        fromServer = [];
      }
    }
    const pending = this.eventNotesAttachments.get(eventId);
    // Pending entries shadow their server twins; Map.has (not a length
    // check) keeps an EMPTIED list authoritative until the server catches
    // up — otherwise a removed last chip re-appears from the server list.
    if (this.eventNotesAttachments.has(eventId) && pending) return pending;
    return fromServer;
  }

  private uploadingEventIds = new Map<string, number>();

  private async onEventNotesFilesSelected(event: DispatchEvent, files: File[]): Promise<void> {
    const eventId = event.event?.id;
    if (!eventId) return;

    // Seed the authoritative pending list from the server metadata on first
    // touch. Reuse getEventNotesAttachments so the server's JSON-string
    // shape parses exactly like every other read path (the raw string
    // would break the later .push calls here on the second upload).
    if (!this.eventNotesAttachments.has(eventId)) {
      this.eventNotesAttachments.set(eventId, this.getEventNotesAttachments(event));
    }
    // An events refresh while an upload is in flight must not drop the
    // seeded list: no attachment edit is queued yet, so the refresh's
    // cleanup would delete the entry and the completed upload would build
    // its list from [] — its full-list save would then REMOVE the links
    // already on the event (CodeRabbit).
    this.uploadingEventIds.set(eventId, (this.uploadingEventIds.get(eventId) ?? 0) + 1);

    try {
    for (const file of files) {
      try {
        const result = await firstValueFrom(
          this.artifactService.createArtifact([{
            contentType: file.type,
            fileSize: file.size,
            name: file.name,
            namespace: 'event-attachment',
            public: true,
          }]),
        );
        const artifact = result.data.createArtifacts.artifacts[0];
        if (!artifact) throw new Error('No artifact returned from server');
        const policy = JSON.parse(artifact.signedPolicy);
        try {
          await firstValueFrom(this.artifactService.uploadFile(file as any, policy));
        } catch (uploadError) {
          // createArtifact succeeded but the upload did not — the public
          // `event-attachment` record would linger with no bytes and no event
          // link (CodeRabbit). Same cleanup rule as the notes-image path.
          try {
            await firstValueFrom(this.artifactService.deleteArtifacts([artifact.id]));
          } catch (cleanupError) {
            console.error('Artifact cleanup failed after failed attachment upload', artifact.id, cleanupError);
          }
          throw uploadError;
        }

        // Copy the current list into a NEW array for this completed upload:
        // a remove click during the upload replaces the map entry, and
        // mutating the stale shared reference would resurrect the removed
        // link (CodeRabbit).
        const current = this.eventNotesAttachments.get(eventId) ?? [];
        const next = [...current, {
          artifactId: artifact.id,
          name: artifact.name || file.name,
          contentType: artifact.contentType || file.type,
          fileSize: artifact.fileSize ?? file.size,
          url: artifact.url,
        }];
        this.eventNotesAttachments.set(eventId, next);
        this.persistEventNotesAttachments(event, next);
      } catch {
        this.messageService.add({
          severity: 'error',
          summary: 'Upload failed',
          detail: `Could not upload "${file.name}"`,
        });
      }
    }
    } finally {
      const left = (this.uploadingEventIds.get(eventId) ?? 1) - 1;
      if (left <= 0) {
        this.uploadingEventIds.delete(eventId);
      } else {
        this.uploadingEventIds.set(eventId, left);
      }
    }
  }

  public onRemoveEventNotesAttachment(event: DispatchEvent, attachment: EventNotesAttachment): void {
    const eventId = event.event?.id;
    if (!eventId) return;

    const attachments = (this.eventNotesAttachments.get(eventId) || this.getEventNotesAttachments(event))
      .filter((a) => a.artifactId !== attachment.artifactId);
    this.eventNotesAttachments.set(eventId, attachments);
    this.persistEventNotesAttachments(event, attachments);
  }

  /**
   * Queue the full attachment list onto the event through the standard
   * pending-change machinery — the save effect merges it into the event's
   * metadata (the same path event notes ride on).
   */
  private persistEventNotesAttachments(event: DispatchEvent, attachments: EventNotesAttachment[]): void {
    const eventId = event.event?.id;
    if (!eventId) return;

    this.store.dispatch(DispatchActions.pendingChangeAdded({
      change: {
        id: `edit-${eventId}-eventAttachments-${Date.now()}`,
        type: 'editEvent',
        eventId,
        eventName: event.event.title,
        eventData: {
          eventAttachments: attachments,
        },
      },
    }));
  }

  public openEventNotesAttachment(attachment: EventNotesAttachment): void {
    if (attachment.url) { window.open(attachment.url, '_blank', 'noopener'); }
  }

  public onCrewNotesContentChanged(event: DispatchEvent, delta: Delta): void {
    const eventId = event.event?.id;
    if (!eventId) return;

    // Programmatic echo: quill fires ngModelChange when writeValue sets the
    // contents we just bound (e.g. after eventsLoaded). The memo still holds
    // that exact reference — a genuine user edit always produces a NEW delta
    // object. Skipping here stops the echo from replacing a pending typed
    // change with the (older) bound value.
    if (this.crewNotesDeltas.get(eventId) === delta) return;

    this.crewNotesDeltas.set(eventId, delta);

    // OPS tasks store notes in event metadata (no job to write to)
    if (event.event?.type === 'ops-task') {
      this.onDayNotesContentChanged(event, delta);
      return;
    }

    if (!this.crewNotesSubjects.has(eventId)) {
      const subject = new Subject<Delta>();
      subject.pipe(debounceTime(300)).subscribe((delta) => {
        this.store.dispatch(DispatchActions.pendingChangeAdded({
          change: {
            id: `crewNotes-${eventId}-${Date.now()}`,
            type: 'editEvent',
            eventId,
            eventName: event.event.title,
            newTitle: event.event.title,
            // Saved to event metadata.eventNotes (NOT job.crewSummary —
            // that is the Workorder Summary the job page shows).
            eventData: { eventNotes: JSON.stringify(delta) },
          },
        }));
      });
      this.crewNotesSubjects.set(eventId, subject);
    }
    this.crewNotesSubjects.get(eventId)!.next(delta);
  }

  // ── Ops-manager day notes (rich text, stored on the event's metadata) ──
  private dayNotesDeltas = new Map<string, Delta>();
  private dayNotesSubjects = new Map<string, Subject<Delta>>();

  public dayNotesQuillModules: QuillModules = {
    toolbar: null,
  };

  /** Parsed Quill delta of the ops-manager event's metadata_dayNotes. */
  public getDayNotesDelta(event: DispatchEvent): Delta {
    const eventId = event.event?.id;
    if (!eventId) return this.emptyCrewNotesDelta;
    // Memoize the reference (same ngx-quill footgun as crew notes).
    if (this.dayNotesDeltas.has(eventId)) {
      return this.dayNotesDeltas.get(eventId)!;
    }
    const meta = event.event?.metadata as any;
    const raw = meta?.dayNotes ?? meta?.metadata_dayNotes;
    let parsed: Delta = this.emptyCrewNotesDelta;
    if (raw) {
      try {
        const delta = typeof raw === 'string' ? JSON.parse(raw) : raw;
        if (delta?.ops) parsed = new Delta(delta.ops);
      } catch {
        parsed = this.emptyCrewNotesDelta;
      }
    }
    this.dayNotesDeltas.set(eventId, parsed);
    return parsed;
  }

  public onDayNotesContentChanged(event: DispatchEvent, delta: Delta): void {
    const eventId = event.event?.id;
    if (!eventId) return;

    // Programmatic echo guard — see onCrewNotesContentChanged.
    if (this.dayNotesDeltas.get(eventId) === delta) return;

    this.dayNotesDeltas.set(eventId, delta);

    if (!this.dayNotesSubjects.has(eventId)) {
      const subject = new Subject<Delta>();
      subject.pipe(debounceTime(300)).subscribe((d) => {
        this.store.dispatch(DispatchActions.pendingChangeAdded({
          change: {
            id: `dayNotes-${eventId}-${Date.now()}`,
            type: 'editEvent',
            eventId,
            eventName: event.event.title,
            newTitle: event.event.title,
            eventData: { dayNotes: JSON.stringify(d) },
          },
        }));
      });
      this.dayNotesSubjects.set(eventId, subject);
    }
    this.dayNotesSubjects.get(eventId)!.next(delta);
  }

  /**
   * Add a reserve block — opens a dialog to name and set time.
   */
  public addReserveBlock(): void {
    this.addCustomBlock('reserve', 'Add Reserve Block');
  }

  /**
   * Add an admin/non-billable block — opens a dialog to name and set time.
   */
  public addAdminBlock(): void {
    this.addCustomBlock('admin', 'Add Admin Time');
  }

  /**
   * Add an ops manager block — opens a dialog to select crew and set time.
   */
  public addOpsManagerBlock(): void {
    this.addCustomBlock('ops-manager', 'Add Ops Manager');
  }

  /**
   * Reset the auto-generated default blocks for the current date: delete the
   * auto-generated ones and re-create every entry from the zone's
   * calendarEvents.defaultBlocks config. Manual blocks are untouched.
   */
  public resetDefaultBlocks(): void {
    this.store.dispatch(DispatchActions.defaultBlocksResetClicked());
  }

  // ── OPS tasks (Ray's OPS section) ─────────────────────────────────────────

  /** Event currently targeted by the ops-task row context menu */
  public opsTaskMenuEvent?: DispatchEvent;

  /** Read an OPS task field from event metadata */
  private opsTaskMeta(event: DispatchEvent): Record<string, any> {
    return (event?.event?.metadata as any) || {};
  }

  public getOpsTaskMeta(event: DispatchEvent): Record<string, any> {
    return this.opsTaskMeta(event);
  }

  /** Card text for the task notes — plain text of the dayNotes Quill delta. */
  public getOpsTaskNotesPlainText(event: DispatchEvent): string {
    const meta = this.opsTaskMeta(event);
    const raw = meta.dayNotes ?? meta.metadata_dayNotes;
    if (raw) return opsTaskNotesPlainText(String(raw));
    // Legacy tasks: description only.
    return event.event?.description || '';
  }

  /** An ops task is completed when its event status is 'completed'. */
  public isOpsTaskCompleted(event: DispatchEvent): boolean {
    return event?.event?.status === 'completed';
  }

  /** Toggle an ops task between completed and its previous/booked status. */
  public toggleOpsTaskCompleted(event: DispatchEvent): void {
    const next = this.isOpsTaskCompleted(event) ? 'booked' : 'completed';
    this.store.dispatch(DispatchActions.pendingChangeAdded({
      change: {
        id: `opsTaskStatus-${event.event.id}-${Date.now()}`,
        type: 'editEvent',
        eventId: event.event.id,
        eventName: event.event.title,
        eventData: { opsTaskStatus: next },
      },
    }));
  }

  /** Open the job associated with an OPS task in the right panel. */
  public openAssociatedJob(event: DispatchEvent): void {
    const jobId = this.opsTaskMeta(event).jobId;
    if (!jobId) return;
    this.router.navigate(['/jobs', 'v3', jobId, 'overview'], {
      queryParams: { zone: 'ymm-toledo' },
    });
  }

  /**
   * Add an OPS task (or edit an existing one when `group`/`event` given).
   */
  public addOpsTask(group?: { group: string; events: DispatchEvent[] }, existing?: DispatchEvent): void {
    const dispatchDate = this.filterEventsForm.controls.date.value || new Date();
    const existingEvent = existing;
    const meta = existingEvent ? this.opsTaskMeta(existingEvent) : {};
    const dayStart = dayjs(dispatchDate).startOf('day').unix();

    this.dialogService.open(OpsTaskDialogComponent, {
      header: existingEvent ? 'Edit OPS Task' : 'Add OPS Task',
      width: '480px',
      data: {
        dispatchDate,
        existingEventId: existingEvent?.event?.id,
        existing: existingEvent ? {
          title: existingEvent.event.title,
          // notes ride in metadata_dayNotes (Quill delta) with a plain-text
          // fallback to the legacy description.
          notes: (meta as any).dayNotes ?? (meta as any).metadata_dayNotes ?? existingEvent.event.description,
          jobId: meta.jobId,
          jobCode: meta.jobCode,
          jobCustomerName: existingEvent.customer?.name,
          status: existingEvent.event.status,
          start: existingEvent.event.start || dayStart + 7 * 3600,
          end: existingEvent.event.end || dayStart + 9 * 3600,
        } : undefined,
      },
    }).onClose.subscribe((result: any) => {
      if (!result) return;

      if (result.delete && existingEvent) {
        this.store.dispatch(DispatchActions.blockDeleted({ eventId: existingEvent.event.id }));
        return;
      }

      const input = {
        title: result.title,
        start: result.start,
        end: result.end,
        notes: result.notes,
        jobId: result.jobId,
        jobCode: result.jobCode,
      };

      if (existingEvent) {
        this.store.dispatch(DispatchActions.opsTaskEdited({
          eventId: existingEvent.event.id,
          eventName: existingEvent.event.title,
          input,
        }));
      } else {
        this.store.dispatch(DispatchActions.opsTaskCreated({
          input: {
            eventId: uuid(),
            selectedDate: dispatchDate,
            ...input,
          },
        }));
      }
    });
  }

  /** Convenience wrapper used by the ops-task card menu */
  public openOpsTaskDialog(group: { group: string; events: DispatchEvent[] }, event?: DispatchEvent): void {
    this.addOpsTask(group, event);
  }

  private addCustomBlock(type: string, header: string): void {
    const dispatchDate = this.filterEventsForm.controls.date.value || new Date();
    // Reserve and non-billable default to 2 hours from 7am (7-9am).
    // Ops manager defaults to all day (7am-5pm).
    const startHour = 7;
    const endHour = type === 'ops-manager' ? 17 : 9;
    const defaultStart = dayjs(dispatchDate).startOf('day').add(startHour, 'hours').unix();
    const defaultEnd = dayjs(dispatchDate).startOf('day').add(endHour, 'hours').unix();

    this.dialogService.open(CustomBlockDialogComponent, {
      header,
      width: '400px',
      data: {
        type,
        dispatchDate,
        defaultStart,
        defaultEnd,
      },
    }).onClose.subscribe((result: { name: string; start: number; end: number; crewRequirement?: any } | undefined) => {
      if (!result) return;

      const blockName = result.name || type;
      const crewReq = result.crewRequirement;

      if (type === 'ops-manager') {
        this.store.dispatch(DispatchActions.opsManagerEventCreated({
          input: {
            eventId: uuid(),
            start: result.start,
            end: result.end,
            selectedDate: dispatchDate,
            description: blockName,
            crewRequirement: crewReq,
          },
        }));
      } else if (type === 'reserve') {
        this.store.dispatch(DispatchActions.reserveEventCreated({
          input: {
            eventId: uuid(),
            start: result.start,
            end: result.end,
            selectedDate: dispatchDate,
            description: blockName,
            crewRequirement: crewReq,
          },
        }));
      } else if (type === 'admin') {
        this.store.dispatch(DispatchActions.nonBillableEventCreated({
          input: {
            eventId: uuid(),
            start: result.start,
            end: result.end,
            description: blockName,
            reason: 'admin' as any,
            selectedDate: dispatchDate,
            crewRequirement: crewReq,
          },
        }));
      }
    });
  }

  /**
   * Handle dropping a crew member from the sidebar onto a route group.
   * Creates the appropriate event type based on the route name:
   * - "Ops Manager" → ops-manager event
   * - "Reserve" → reserve event
   * - "Admin" → non-billable event (admin)
   * - Truck name → reserve event tied to that truck (assetIds)
   * If the route already has events, assigns crew to all events on that route.
   * Auto-promotes the first capable crew member to crew lead if none exists.
   */
  private resolveCrewLeadRole(
    targetEvents: DispatchEvent[],
    userId: string,
    crewCapabilities?: string[],
  ): string {
    if (!crewCapabilities?.includes(CAPABILITIES_BACKEND_MAP[EventAttendeeRoles.crewLead])) {
      return EventAttendeeRoles.crewMember;
    }
    const hasCrewLead = targetEvents.some((e) =>
      e.crew.some((c) => c.user.id === userId
        ? c.role === EventAttendeeRoles.crewLead || c.role === EventAttendeeRoles.assistantCrewLead
        : c.role === EventAttendeeRoles.crewLead),
    );
    if (hasCrewLead) return EventAttendeeRoles.crewMember;
    const hasAnyCrew = targetEvents.some((e) => e.crew.some((c) => c.user.id !== userId));
    if (!hasAnyCrew) return EventAttendeeRoles.crewLead;
    return EventAttendeeRoles.crewMember;
  }

  public onRouteDrop(event: CdkDragDrop<{ group: string; events: DispatchEvent[] }>): void {
    if (!event || !event.item) return;

    const dragData = event.item.data as { attendee?: any } | undefined;
    const crew = dragData?.attendee;
    if (!crew) return;

    // Handle both PotentialCrewMember (from sidebar) and plain objects (from route chips)
    const userId = crew.user?.id || crew.userId || (typeof crew === 'string' ? crew : null);
    const crewName = crew.name || crew.user?.name || '';
    if (!userId) return;

    // Resolve capabilities — drag data from route chips doesn't include them,
    // so look up from the potential crew list in the store.
    let userCapabilities = crew.user?.capabilities;
    if (!userCapabilities) {
      let crewFromStore: PotentialCrewMember | undefined;
      this.store.select(selectPotentialCrew).pipe(take(1)).subscribe((list) => {
        crewFromStore = list.find((c) => c.user.id === userId);
      });
      userCapabilities = crewFromStore?.user?.capabilities;
    }

    const routeName = event.container.data?.group;
    if (!routeName) return;

    // If dropped in the same container, do nothing
    if (event.previousContainer === event.container) return;

    const dispatchDate = this.filterEventsForm.controls.date.value || new Date();
    const start = dayjs(dispatchDate).startOf('day').add(7, 'hours').unix();
    const end = dayjs(dispatchDate).startOf('day').add(9, 'hours').unix();

    // Check if dropping onto a special route (by inspecting its events' types)
    const routeEvents = event.container.data?.events || [];
    const firstEventType = routeEvents[0]?.event?.type;

    if (routeEvents.length > 0 && firstEventType) {
      // Dropping onto an existing special route — add crew to those events
      if (firstEventType === 'ops-manager' || firstEventType === 'reserve' || firstEventType === 'non-billable') {
        // Queue addCrew to all events on this special route
        const prevRouteData = event.previousContainer.data as { group: string; events: DispatchEvent[] } | undefined;
        const removeEdits = prevRouteData?.events
          ? prevRouteData.events
              .filter((e) => e.crew.some((c) => c.user.id === userId))
              .map((e) => ({
                eventId: e.event.id,
                eventName: e.event.title,
                removeAttendees: [{
                  user: { id: userId },
                  role: e.crew.find((c) => c.user.id === userId)?.role || EventAttendeeRoles.crewMember,
                } as any],
              }))
          : [];

        const resolvedRole = this.resolveCrewLeadRole(routeEvents, userId, userCapabilities);

        const addEdits = routeEvents.map((e) => ({
          eventId: e.event.id,
          eventName: e.event.title,
          addAttendees: [{
            user: { id: userId },
            name: crewName,
            role: resolvedRole,
          } as any],
        }));

        this.store.dispatch(DispatchActions.pendingChangeAndOptimisticUpdate({
          change: {
            id: `move-${userId}-${Date.now()}`,
            type: 'moveCrew',
            eventId: routeEvents[0].event.id,
            eventName: routeEvents[0].event.title,
            userId,
            userName: crewName,
            role: resolvedRole,
            fromEvents: prevRouteData?.events
              ?.filter((e) => e.crew.some((c) => c.user.id === userId))
              .map((e) => ({
                eventId: e.event.id,
                eventName: e.event.title,
                role: e.crew.find((c) => c.user.id === userId)?.role || EventAttendeeRoles.crewMember,
              })) || [],
            toEvents: routeEvents.map((e) => ({ eventId: e.event.id, eventName: e.event.title })),
          },
          edits: [...removeEdits, ...addEdits],
        }));
      } else if (routeEvents.length) {
        // Route has job events — queue a single moveCrew change
      const prevRouteData = event.previousContainer.data as { group: string; events: DispatchEvent[] } | undefined;

      // Build from/to event lists
      const fromEvents = prevRouteData?.events
        ? prevRouteData.events
            .filter((e) => e.crew.some((c) => c.user.id === userId))
            .map((e) => ({
              eventId: e.event.id,
              eventName: e.event.title,
              role: e.crew.find((c) => c.user.id === userId)?.role || EventAttendeeRoles.crewMember,
            }))
        : [];

      const toEvents = routeEvents.map((e) => ({
        eventId: e.event.id,
        eventName: e.event.title,
      }));

      // Single pending change for the whole move + optimistic update
      const removeEdits = prevRouteData?.events
        ? prevRouteData.events
            .filter((e) => e.crew.some((c) => c.user.id === userId))
            .map((e) => ({
              eventId: e.event.id,
              eventName: e.event.title,
              removeAttendees: [{
                user: { id: userId },
                role: e.crew.find((c) => c.user.id === userId)?.role || EventAttendeeRoles.crewMember,
              } as any],
            }))
        : [];

      const resolvedRole = this.resolveCrewLeadRole(routeEvents, userId, userCapabilities);

      const addEdits = routeEvents.map((e) => ({
        eventId: e.event.id,
        eventName: e.event.title,
        addAttendees: [{
          user: { id: userId },
          name: crewName,
          role: resolvedRole,
        } as any],
      }));

      this.store.dispatch(DispatchActions.pendingChangeAndOptimisticUpdate({
        change: {
          id: `move-${userId}-${Date.now()}`,
          type: 'moveCrew',
          eventId: toEvents[0]?.eventId || '',
          eventName: toEvents[0]?.eventName || '',
          userId,
          userName: crewName,
          role: resolvedRole,
          fromEvents,
          toEvents,
        },
        edits: [...removeEdits, ...addEdits],
      }));
    } else {
      // Empty truck route — create a reserve event and queue removal from old route
      const prevRouteData = event.previousContainer.data as { group: string; events: DispatchEvent[] } | undefined;

      // If coming from a special route (reserve/admin/ops-manager), remove from old event
      if (prevRouteData?.events) {
        for (const e of prevRouteData.events) {
          if (e.crew.some((c) => c.user.id === userId)) {
            // If it's a synthetic temp event, just remove optimistically — it'll be
            // replaced on next refresh. If it's a real event, delete it.
            if (e.event.id.startsWith('temp-')) {
              this.store.dispatch(DispatchActions.pendingChangeAndOptimisticUpdate({
                change: {
                  id: `remove-${userId}-${Date.now()}`,
                  type: 'removeCrew',
                  eventId: e.event.id,
                  eventName: e.event.title,
                  userId,
                  userName: crewName,
                  role: e.crew.find((c) => c.user.id === userId)?.role || EventAttendeeRoles.crewMember,
                },
                edits: [{
                  eventId: e.event.id,
                  eventName: e.event.title,
                  removeAttendees: [{
                    user: { id: userId },
                    role: e.crew.find((c) => c.user.id === userId)?.role || EventAttendeeRoles.crewMember,
                  } as any],
                }],
              }));
            } else {
              // Real event — queue a removeCrew change (will be saved with Save)
              this.store.dispatch(DispatchActions.pendingChangeAndOptimisticUpdate({
                change: {
                  id: `remove-${userId}-${Date.now()}`,
                  type: 'removeCrew',
                  eventId: e.event.id,
                  eventName: e.event.title,
                  userId,
                  userName: crewName,
                  role: e.crew.find((c) => c.user.id === userId)?.role || EventAttendeeRoles.crewMember,
                },
                edits: [{
                  eventId: e.event.id,
                  eventName: e.event.title,
                  removeAttendees: [{
                    user: { id: userId },
                    role: e.crew.find((c) => c.user.id === userId)?.role || EventAttendeeRoles.crewMember,
                  } as any],
                }],
              }));
            }
          }
        }
      }

      // Create the new reserve event for this truck
      this.store.dispatch(DispatchActions.reserveEventCreated({
        input: { eventId: uuid(), userId, start, end, selectedDate: dispatchDate },
      }));
      }
    } else {
      // No events on route — create a new reserve event
      this.store.dispatch(DispatchActions.reserveEventCreated({
        input: { eventId: uuid(), userId, start, end, selectedDate: dispatchDate },
      }));
    }
  }

  public openPrintBolsDialog() {
    this.dialogService.open(PrintDispatchBolsDialogComponent, {
        header: 'Print BOLs',
        width: '50vw',
        data: {
            events: this.events
        }
    });
  }

  public closeDialog() {
    this.visible = false;
    this.eventUnderEditting = null;
  }

  public closeSendScheduleDialog() {
    this.isSendScheduleDialogVisible = false;
  }

  public closeCrewSettingsDialog() {
    this.store.dispatch(DispatchActions.editCrewSettingsDialogClosed());
  }

  public nextCrewMember() {
    this.store.dispatch(DispatchActions.nextCrewMemberClicked());
  }

  public previousCrewMember() {
    this.store.dispatch(DispatchActions.previousCrewMemberClicked());
  }

  private watchEventSelectors() {
    this.subs.sink = this.events$.subscribe((events) => {
      this.events = events
    })
    // Live dispatch: dayEventsUpdated arrives already unwrapped from the
    // store's subscribe() (which maps res.data.dayEventsUpdated). Refresh
    // the board when the mutated days intersect the viewed day's window.
    // The subscription outlives backend restarts: errors are swallowed and
    // the websocket client's own retry logic (retryAttempts: Infinity)
    // re-establishes the socket, but an errored subscription stays dead —
    // so restart the subscription after any failure.
    this.subs.sink = this.dayEventsUpdatedGQL.subscribe().pipe(
      // An errored subscription stays dead (the ws client's Infinity retry
      // re-establishes the socket but the graphql op needs re-subscribing) —
      // retry forever with a 2s backoff.
      retry({ delay: () => timer(2000) }),
    ).subscribe({
      next: (mutated: DayEventsMutated) => {
        if (!mutated?.zone?.length) return;
        const viewed = dayjs(this.filterEventsForm.controls.date.value).format('YYYY-MM-DD');
        const inRange = mutated.dates.some((d) => Math.abs(dayjs(d).diff(dayjs(viewed), 'day')) <= 7);
        if (inRange) {
          this.store.dispatch(DispatchActions.hardRefreshEvents({ date: null }));
        }
      },
    });
    // Refresh events after save: the reducer's optimistic updates already
    // reflect the change, and clearing the local editor-override maps lets
    // the server state flow into the editors (so edits made by a second
    // dispatcher — or in the job editor — sync here too).
    this.subs.sink = this.eventsLoaded$.subscribe((loaded) => {
      if (loaded) {
        this.hasLoadedOnce = true;
        this.eventsLoaded = true;
        // Drop local overrides so fresh server data (job metadata included)
        // shows through. Pending changes still queued keep their overrides —
        // including the attachment overrides of editEvent changes that carry
        // eventAttachments (clearing those would snap the chips back to the
        // stale server list until the queued save replayed).
        this.store.select(selectPendingChanges).pipe(take(1)).subscribe((pendingChanges) => {
          const pendingAttachmentEventIds = new Set([
            ...this.uploadingEventIds.keys(),
            ...pendingChanges
              .filter((change) => change.type === 'editEvent'
                && change.eventData?.eventAttachments !== undefined)
              .map((change) => change.eventId),
          ]);
          for (const eventId of this.eventNotesAttachments.keys()) {
            if (!pendingAttachmentEventIds.has(eventId)) {
              this.eventNotesAttachments.delete(eventId);
            }
          }
        });
        this.opsNotesValues.clear();
        this.opsNotesInitialized.clear();
        this.crewNotesDeltas.clear();
        this.crewNotesInitialized.clear();
        this.dayNotesDeltas.clear();
      }
    })
    // Stop progress bar when assign crew finishes
    this.subs.sink = this.assigningCrewWithAI$.pipe(
      skip(1),
      filter((loading) => !loading),
    ).subscribe(() => {
      this.stopAssignCrewProgress();
    })
  }
  private loadEvents(): void {
    const date = this.route.snapshot.queryParamMap.get('date') || sessionStorage.getItem(environment.lskeys.scheduleDate);
    const parsedDate = date ? dayjs(date).toDate() : new Date();
    this.store.dispatch(DispatchActions.hardRefreshEvents({ date: parsedDate }));
    this.filterEventsForm.controls.date.setValue(parsedDate, { emitEvent: false });
    // Reopen on the last date the dispatcher was viewing (Ray: last-used date
    // not saved/loaded) — persist it whenever it changes.
    this.saveLastDispatchDate(parsedDate);
  }

  /** Persist the dispatch date so the page reopens on it (per zone). */
  private saveLastDispatchDate(date: Date): void {
    try {
      const iso = dayjs(date).format('YYYY-MM-DD');
      sessionStorage.setItem(environment.lskeys.scheduleDate, iso);
      const url = new URL(window.location.href);
      url.searchParams.set('date', iso);
      history.replaceState(null, '', url.toString());
    } catch {
      // sessionStorage unavailable (private mode) — non-fatal
    }
  }

  /** Assign Crew / Send schedule now live in the shared controls bar; the
   *  emphasized (filled) states and the AI loading spinner come from the
   *  same observables the old header buttons listened to. */
  private buildDispatchActions(
      aiEnabled: boolean,
      reqsSatisfied: boolean,
      assigningCrew: boolean): ScheduleControlsAction[] {
    const actions: ScheduleControlsAction[] = [
      {
        id: 'send-schedule',
        label: 'Send schedule',
        icon: 'pi pi-envelope',
        menuItems: () => this.sendScheduleItems,
        split: true,
        filled: reqsSatisfied,
        onClick: () => this.openSendScheduleDialog(),
      },
    ];
    if (aiEnabled) {
      actions.unshift({
        id: 'assign-crew',
        label: 'Assign Crew',
        icon: 'pi pi-sparkles',
        menuItems: () => this.assignCrewItems,
        split: true,
        loading: assigningCrew,
        filled: !reqsSatisfied,
        onClick: () => this.assignCrewWithAI(),
      });
    }
    return actions;
  }

  /** Keep the bar's actions in step with the AI-assign feature flag, the
   *  requirement-satisfaction state and the assigning spinner. */
  private watchControlsActions(): void {
    this.subs.sink = combineLatest([
      this.aiAssignCrewEnabled$,
      this.areEventRequirementsSatisfied$,
      this.assigningCrewWithAI$,
    ]).subscribe(([aiEnabled, reqsSatisfied, assigningCrew]) => {
      const actions = this.buildDispatchActions(!!aiEnabled, !!reqsSatisfied, !!assigningCrew);
      // setConfig ignores the call only when the object reference matches,
      // so rebuilding the actions above keeps the bar fresh.
      this.controlsConfig = {
        ...(this.controlsConfig || {
          mode: 'day',
          onGear: (event) => this.gearMenu?.toggle(event),
          onRefresh: () => {
            // The wait is built and connected BEFORE the hard-refresh
            // dispatch so it can't miss a fast completion (CodeRabbit).
            const done$ = this.refreshDone();
            this.hardRefreshComponent();
            return done$;
          },
        }),
        actions,
      };
      // Register OUTSIDE the synchronous first emission (it lands during
      // ngOnInit; the bar's bindings were already checked — NG0100), with
      // Map/tab's ownership guard so a stale microtask cannot clobber a
      // newer config write (CodeRabbit).
      const config = this.controlsConfig;
      queueMicrotask(() => {
        if (this.controlsConfig === config) {
          this.controls.setConfig(config);
          // This tab renders no summary strip: it belongs to the
          // day/week/month schedule tab — clear the day tab's leftovers.
          this.controls.summary.set(null);
        }
      });
    });
  }
  private watchZoneChange(): void {
    this.subs.sink = this.brandingService.currentZone().pipe(skip(1)).subscribe((_zone) => {
      // Zone switch must not show the previous zone's rows behind the
      // skeleton — drop the sticky flag so the first-load skeleton shows.
      this.hasLoadedOnce = false;
      this.hardRefreshComponent();
    });
  }

  private watchEventUpdates() {
    this.subs.sink = this.detailsHelper.getObjectUpdates('Events').subscribe((update) => {
      if (update.action === 'update') {
        this.store.dispatch(DispatchActions.hardRefreshEvents({ date: null }));
      }
    });
  }

  private dispatchEventsForDate(date: Date): void {
    this.eventsLoaded = false;
    this.store.dispatch(DispatchActions.setDispatchDate({ date }));
  }

  private watchDateChange(): void {
    this.subs.sink = this.filterEventsForm.controls.date.valueChanges.pipe(debounceTime(300)).subscribe((date: Date) => {
      this.dispatchEventsForDate(date);
      this.saveLastDispatchDate(date);
    });
  }

  private watchGroupByChanges(): void {
    this.subs.sink = this.filterEventsForm.controls.groupBy.valueChanges.subscribe((options) => {
      this.store.dispatch(DispatchActions.setGroupBy({ groupBy: options.label }));
      this.activeGroupBy = options.label;
    });
  }

  private watchEventStatusChange(): void {
    this.subs.sink = this.filterEventsForm.controls.eventStatus.valueChanges.subscribe(({ label }) => {
      this.store.dispatch(DispatchActions.setEventStatus({ eventStatus: label }));
    });
  }

  public isResourceFromDispatchEvent(item: CdkDrag<AttendeeDragData | AssetDragData>) {
    return 'event' in item.data;
  }

  /**
   * D-4 (Maria): trucks could be dropped on the event crew zone but nothing
   * happened — only attendee drags may enter the crew drop zone now.
   */
  public attendeesOnlyDragPredicate(item: CdkDrag<AttendeeDragData | AssetDragData>) {
    return !!item.data && 'attendee' in item.data;
  }

  public removeResource($event: CdkDragDrop<any, any, AttendeeDragData | AssetDragData>) {
    const { item } = $event;
    const { data } = item || {};

    if (!data?.event?.event?.id) return;

    const { attendee } = data as AttendeeDragData;
    const { asset } = data as AssetDragData;

    if (!attendee && !asset) return;

    const {
      event: { id: eventId },
      customer: { name: eventName = '' },
      crew = [],
    } = data?.event || {};
    const edit = {
      eventId,
      eventName,
      addAttendees: [],
      removeAttendees: attendee ? [{ user: attendee.user, role: attendee.role, name: attendee.name }] : [],
      removeAssets: asset ? [{ id: asset.id, name: asset.name }] : [],
    }

    if (attendee) {
      const isCrewLead = attendee.role === EventAttendeeRoles.crewLead;
      // If we are removing a crew Leader, we need to assign the next available user as crew lead
      const hasAnotherCrewLead = crew.some(({ role, user }) => role === EventAttendeeRoles.crewLead && user.id !== attendee.user.id);

      if (isCrewLead && !hasAnotherCrewLead && crew.length > 1) {
        // Pick next crew lead as any member other than the one we are removing
        const nextCrewLead = crew.find(({ role, user }) => role === EventAttendeeRoles.crewMember && user.id !== attendee.user.id);
        edit.addAttendees.push({ user: nextCrewLead.user, role: EventAttendeeRoles.crewLead, name: nextCrewLead.name });
        edit.removeAttendees.push({ user: nextCrewLead.user, role: nextCrewLead.role, name: nextCrewLead.name });
      }

    }

    this.store.dispatch(DispatchActions.updateCrew({ edits: [edit] }));
  }

  public changeDate(dateType: 'prev' | 'next' | 'today') {
    const date = this.filterEventsForm.controls.date.value;
    const dayJsObj = dayjs(date);
    let newDate: Date = new Date();

    switch (dateType) {
      case 'prev':
        newDate = dayJsObj.subtract(1, 'day').toDate();
        break;
      case 'next':
        newDate = dayJsObj.add(1, 'day').toDate();
        break;
      case 'today':
      default:
        break;
    }

    this.filterEventsForm.controls.date.setValue(newDate);
  }

  public hardRefreshComponent() {
    this.eventsLoaded = false;
    this.store.dispatch(DispatchActions.componentHardRefreshed());
  }

  public openCalendarRemarksDialog() {
    // Wall-date the user picked on the dispatch board, formatted the same
    // way the board itself treats the control (browser-local, no tz shift).
    const date = this.filterEventsForm.controls.date.value;
    this.store.dispatch(DispatchCalendarRemarksDialogActions.dialogOpened({
      date: date ? dayjs(date).format('YYYY-MM-DD') : null,
    }));
  }

  public scrollToEvent(index: string) {
    const eventCard = document.getElementById(`event-${index}`);
    if (eventCard) {
      eventCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
      eventCard.classList.add('highlight-card');
      setTimeout(() => {
        eventCard.classList.remove('highlight-card');
      }, 2000); // Remove highlight after 2 seconds
    }
  }

  private async writeToClipboard(content: string, type: 'html' | 'text'): Promise<boolean> {
    try {
      if (type === 'html') {
        const blobHtml = new Blob([content], { type: 'text/html' });
        const blobText = new Blob([content], { type: 'text/plain' });
        const data = [new ClipboardItem({ 'text/html': blobHtml, 'text/plain': blobText })];
        await navigator.clipboard.write(data);
      } else {
        await navigator.clipboard.writeText(content);
      }
      return true;
    } catch (err) {
      console.error('Failed to copy: ', err);
      return false;
    }
  }

  /**
   * Format phone number for display, with fallback for missing phone
   */
  private formatPhone(phone: string | null | undefined): string {
    return phone || 'Phone not provided';
  }

  /**
   * Check if copying is already in progress
   */
  private isCopyOperationInProgress(): boolean {
    if (this.isCopyingSchedule) {
      this.messageService.add({
        severity: 'info',
        summary: 'Please wait',
        detail: 'Already preparing schedule for copy...'
      });
      return true;
    }
    return false;
  }

  /**
   * Fetch all job details and distances for the current events
   */
  private async fetchAllJobData(): Promise<void> {
    // Collect all job IDs that need details
    const jobIds = new Set<string>();
    this.events.forEach(group => {
      group.events.forEach(event => {
        const jobId = event.event?.job?.id;
        if (jobId) jobIds.add(jobId);
      });
    });

    // Fetch all job details in parallel
    const fetchPromises = Array.from(jobIds).map(id => this.fetchJobDetailsForCopy(id));
    await Promise.all(fetchPromises);

    // Calculate distances for all jobs in parallel
    const distancePromises: Promise<any>[] = [];
    for (const jobId of jobIds) {
      const job = this.jobDetailsMap.get(jobId);
      if (job) {
        distancePromises.push(this.calculateDistancesForCopy(jobId, job));
      }
    }
    await Promise.all(distancePromises);
  }

  private toTitleCase(str: string): string {
    if (!str) return '';
    return str.replace(
      /\w\S*/g,
      text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
    );
  }

  private formatCurrency(amount: number, currency: string = 'USD'): string {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(amount / 100);
  }

  private calculateWeight(job: any): number {
    if (!job?.fields) return 0;
    const inventoryField = job.fields.find((f: any) => f.label === 'Inventory');
    if (!inventoryField?.values?.[0]?.value) return 0;

    let weight = 0;
    try {
      const inventoryData = JSON.parse(inventoryField.values[0].value);
      if (inventoryData?.rooms) {
        inventoryData.rooms.forEach((room: any) => {
          if (room.inventory) {
            room.inventory.forEach((item: any) => {
               weight += (Number(item.weight) || 0) * (Number(item.quantity) || 0);
            });
          }
        });
      }
    } catch (e) {
      console.warn('Failed to parse inventory', e);
    }
    return weight;
  }

  public async copyScheduleHtml() {
    // Prevent multiple simultaneous copy operations
    if (this.isCopyOperationInProgress()) return;

    this.isCopyingSchedule = true;
    this.messageService.add({
      severity: 'info',
      summary: 'Preparing schedule',
      detail: 'Fetching job details...'
    });

    try {
      // Fetch all job data
      await this.fetchAllJobData();

      // Build ExportableEvent array
      const exportableEvents: ExportableEvent[] = [];

      this.events.forEach(group => {
        group.events.forEach(event => {     
          const currency = event.event?.job?.currency || 'USD';
          const jobId = event.event?.job?.id;
          const jobDetails = jobId ? this.jobDetailsMap.get(jobId) || null : null;
          const distanceData = jobId ? this.calculatedDistancesMap.get(jobId) || null : null;
          
          // Travel time and mileage from calculated distances
          let travelTimeStr = 'N/A';
          let mileageStr = 'N/A';
          if (distanceData) {
            const travelMinutes = Math.round((distanceData.estimatedTime || 0) / 60);
            travelTimeStr = formatTravelTime(travelMinutes);
            const unit = this.getDistanceUnitLabel();
            mileageStr = formatDistance(distanceData.totalDistance || 0, unit);
          }

          // Inventory
          const inventory = jobDetails ? parseInventory(jobDetails) : null;

          exportableEvents.push({
            startTime: event.startTime,
            jobCode: event.event?.job?.code || '',
            jobUrl: event.event?.job?.id ? `${window.location.origin}/jobs/${event.event.job.id}` : '',
            type: this.toTitleCase(event.event.type),
            status: this.toTitleCase(event.event.status),
            customerName: event.customer.name,
            customerPhone: this.formatPhone(event.customer.user?.phone),
            arrivalWindow: formatArrivalWindow(event.event.start, this.timezone),
            duration: formatDuration(event.event.start, event.event.end, this.timezone),
            travelTime: travelTimeStr,
            mileage: mileageStr,
            locations: this.formatLocationsForText(event, jobDetails),
            weight: formatInventoryWeight(inventory),
            volume: formatInventoryVolume(inventory),
            revenue: event.event.discountedSubTotal,
            currency,
            totalLaborCost: event.totalLaborCost,
            laborPercentage: event.laborPercentage + '%',
            trucks: event.trucks.map(t => t.name).join(', '),
            crew: event.crew.map(c => `${c.name} (${c.role})`).join(', '),
            truckCount: event.trucks.length,
            crewCount: event.crew.length,
            crewRequirement: event.crewRequirement || 0
          });
        });
      });

      const html = generateScheduleHtml(exportableEvents);
      
      const success = await this.writeToClipboard(html, 'html');
      if (success) {
        this.messageService.add({
          severity: 'success',
          summary: 'Schedule copied',
          detail: 'The schedule has been copied to your clipboard.'
        });
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to copy schedule. Please try again.'
        });
      }
    } catch (error) {
      console.error('Error copying schedule:', error);
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to copy schedule. Please try again.'
      });
    } finally {
      this.isCopyingSchedule = false;
    }
  }

  /**
   * Fetch job details for a specific job ID (for Copy for Chat functionality)
   */
  private async fetchJobDetailsForCopy(jobId: string): Promise<JobDetailsV2Fragment | null> {
    if (this.jobDetailsMap.has(jobId)) {
      return this.jobDetailsMap.get(jobId)!;
    }

    try {
      const result = await firstValueFrom(
        this.jobsV3PageGQL.fetch({
          jobId,
          resolve: ['discounts', 'users', 'locations', 'distances', 'artifacts', 'charges']
        })
      );
      const job = result.data?.jobs?.jobs?.[0];
      if (job) {
        this.jobDetailsMap.set(jobId, job as JobDetailsV2Fragment);
        return job as JobDetailsV2Fragment;
      }
    } catch (e) {
      console.error('Failed to fetch job details for copy:', e);
    }
    return null;
  }

  /**
   * Calculate distances for a job (for Copy for Chat functionality)
   */
  private async calculateDistancesForCopy(jobId: string, job: JobDetailsV2Fragment): Promise<CalculateDistanceOutput | null> {
    if (this.calculatedDistancesMap.has(jobId)) {
      return this.calculatedDistancesMap.get(jobId)!;
    }

    const locationIds = getOrderedLocationIdsForCalculation(job.locations || []);
    if (locationIds.length < 2) return null;

    try {
      const result = await firstValueFrom(
        this.calculateDistanceGQL.fetch({ locationIds, units: this.distanceUnits })
      );
      const distanceOutput = result.data?.calculateDistance;
      if (distanceOutput) {
        this.calculatedDistancesMap.set(jobId, distanceOutput);
        return distanceOutput;
      }
    } catch (e) {
      console.error('Failed to calculate distances for copy:', e);
    }
    return null;
  }

  /**
   * Get the distance unit label ('km' or 'mi')
   */
  private getDistanceUnitLabel(): 'km' | 'mi' {
    return this.distanceUnits === 'metric' ? 'km' : 'mi';
  }

  /**
   * Format locations for text display
   */
  private formatLocationsForText(event: DispatchEvent, jobDetails: JobDetailsV2Fragment | null): string {
    const eventLocations = event.event.locations || [];
    const jobLocations = jobDetails?.locations || [];
    const locations = getOrderedLocationsForDisplay(eventLocations, jobLocations);
    
    if (locations.length === 0) return '';
    
    return locations
      .map((loc: any) => {
        const label = getLocationLabel(loc.type);
        const address = loc.location?.addressLineOne || loc.location?.name || 'Unknown';
        return `${label}: ${address}`;
      })
      .join('; ');
  }

  public async copyScheduleText() {
    // Prevent multiple simultaneous copy operations
    if (this.isCopyOperationInProgress()) return;

    this.isCopyingSchedule = true;
    this.messageService.add({
      severity: 'info',
      summary: 'Preparing schedule',
      detail: 'Fetching job details...'
    });

    try {
      // Fetch all job data using shared method
      await this.fetchAllJobData();

      // Now build the text output
      let text = `Schedule for ${dayjs(this.filterEventsForm.value.date).format('MMM D, YYYY')}\n\n`;
      const crewStartTimes = new Map<string, { name: string, start: number }>();

      this.events.forEach(group => {
        let groupStarted = false;

        group.events.forEach(event => {
          if (event.crew.length === 0) { return; }
          if (!groupStarted && group.group && group.group !== 'undefined') {
            text += `--- ${group.group} ---\n`;
            groupStarted = true;
          }
          
          const currency = event.event?.job?.currency || 'USD';
          const jobId = event.event?.job?.id;
          const jobDetails = jobId ? this.jobDetailsMap.get(jobId) || null : null;
          const distanceData = jobId ? this.calculatedDistancesMap.get(jobId) || null : null;

          // Basic info
          const startTime = event.startTime;
          const jobCode = event.event?.job?.code || '';
          const type = this.toTitleCase(event.event.type);
          const status = this.toTitleCase(event.event.status);
          const customer = event.customer.name;
          const customerPhone = this.formatPhone(event.customer.user?.phone);
          const total = this.formatCurrency(event.event.discountedSubTotal, currency);
          const trucks = event.trucks.map(t => t.name).join(', ');
          const crew = event.crew.map(c => `${c.name} (${c.role})`).join(', ');

          // New fields
          const arrivalWindow = formatArrivalWindow(event.event.start, this.timezone);
          const duration = formatDuration(event.event.start, event.event.end, this.timezone);
          
          // Travel time and mileage from calculated distances
          let travelTimeStr = 'N/A';
          let mileageStr = 'N/A';
          if (distanceData) {
            const travelMinutes = Math.round((distanceData.estimatedTime || 0) / 60);
            travelTimeStr = formatTravelTime(travelMinutes);
            const unit = this.getDistanceUnitLabel();
            mileageStr = formatDistance(distanceData.totalDistance || 0, unit);
          }

          // Locations
          const locationsStr = this.formatLocationsForText(event, jobDetails);

          // Crew summary from job
          const crewSummary = event.event?.job?.crewSummary;
          const summaryParagraphs = parseCrewSummary(crewSummary);
          const summaryText = summaryParagraphs.length > 0 ? summaryParagraphs.join(' ') : '';

          // Inventory
          const inventory = jobDetails ? parseInventory(jobDetails) : null;
          const weightStr = formatInventoryWeight(inventory);
          const volumeStr = formatInventoryVolume(inventory);

          // Crew requirement
          const crewRequirement = event.crewRequirement || 0;
          const currentCrew = event.crew.length;

          // Track crew start times
          event.crew.forEach(member => {
            const current = crewStartTimes.get(member.user.id);
            if (!current || event.event.start < current.start) {
              crewStartTimes.set(member.user.id, { name: member.name, start: event.event.start });
            }
          });

          // Build the text block for this event
          text += `${startTime} - ${jobCode} - ${customer}\n`;
          text += `Phone: ${customerPhone}\n`;
          text += `Type: ${type} | Status: ${status} | Total: ${total}\n`;
          text += `Arrival Window: ${arrivalWindow}\n`;
          text += `Duration: ${duration} | Travel Time: ${travelTimeStr} | Mileage: ${mileageStr}\n`;
          if (locationsStr) text += `Locations: ${locationsStr}\n`;
          text += `Inventory: ${weightStr} | ${volumeStr}\n`;
          if (trucks) text += `Truck: ${trucks}\n`;
          text += `Crew: (${currentCrew}/${crewRequirement}) ${crew}\n`;
          if (summaryText) text += `Summary: ${summaryText}\n`;
          text += '\n';
        });
      });

      if (crewStartTimes.size > 0) {
        text += '--- Crew Start Times ---\n';
        const sortedCrew = Array.from(crewStartTimes.values()).sort((a, b) => {
          if (a.start !== b.start) return a.start - b.start;
          return a.name.localeCompare(b.name);
        });

        sortedCrew.forEach(c => {
          const time = dayjs(c.start * 1000).format('h:mm A');
          text += `${c.name}: ${time}\n`;
        });
      }

      const success = await this.writeToClipboard(text, 'text');
      if (success) {
        this.messageService.add({
          severity: 'success',
          summary: 'Schedule copied',
          detail: 'The schedule has been copied to your clipboard.'
        });
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to copy schedule. Please try again.'
        });
      }
    } catch (error) {
      console.error('Error copying schedule:', error);
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to copy schedule. Please try again.'
      });
    } finally {
      this.isCopyingSchedule = false;
    }
  }

  ngAfterViewChecked(): void {
    // Set initial textarea values for ops notes that haven't been initialized
    // yet. We can't use [value] binding because Angular resets the DOM value on
    // every change detection cycle, which steals focus from the textarea during
    // typing. (Crew notes are a Quill editor bound via [content] and don't need
    // this workaround.)
    if (!this.events?.length) return;
    for (const group of this.events) {
      if (!group.events?.length) continue;
      for (const ev of group.events) {
        const eventId = ev.event?.id;
        if (!eventId) continue;
        if (!this.opsNotesInitialized.has(eventId)) {
          const ta = document.getElementById('ops-notes-' + eventId) as HTMLTextAreaElement;
          if (ta) {
            const val = this.getOpsNotes(ev);
            if (ta.value !== val) {
              ta.value = val;
            }
            this.opsNotesInitialized.add(eventId);
          }
        }
      }
    }
  }

  ngOnDestroy(): void {
    if (this.assignCrewProgressTimer) clearInterval(this.assignCrewProgressTimer);
    if (this.assignCrewProgressTimeout) clearTimeout(this.assignCrewProgressTimeout);
    this.subs.unsubscribe();
    if (this.controlsConfig) {
      this.controls.clearConfig(this.controlsConfig);
      // Null AFTER clear so a queued registration microtask cannot restore
      // the destroyed tab's config (CodeRabbit).
      this.controlsConfig = null;
    }
  }
}
